var Pr = Object.defineProperty;
var sn = (e) => {
  throw TypeError(e);
};
var Wr = (e, t, n) => t in e ? Pr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var z = (e, t, n) => Wr(e, typeof t != "symbol" ? t + "" : t, n), Mt = (e, t, n) => t.has(e) || sn("Cannot " + n);
var M = (e, t, n) => (Mt(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Y = (e, t, n) => t.has(e) ? sn("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), D = (e, t, n, r) => (Mt(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), pe = (e, t, n) => (Mt(e, t, "access private method"), n);
import { useRef as nt, useState as Gr, useMemo as Ur } from "react";
function zn() {
  return globalThis.__autoTracerInternal || (globalThis.__autoTracerInternal = {
    outputMode: "devtools",
    subscribers: []
  }), globalThis.__autoTracerInternal.sharedComponentRegistry || (globalThis.__autoTracerInternal.sharedComponentRegistry = {
    trackedGUIDs: /* @__PURE__ */ new Set(),
    trackedNames: /* @__PURE__ */ new Map()
  }), globalThis.__autoTracerInternal.sharedComponentRegistry;
}
function Pt() {
  return zn().trackedGUIDs;
}
function kt(e) {
  let t = e.memoizedState;
  for (; t; ) {
    const n = t.memoizedState;
    if (n && typeof n == "object" && "current" in n && typeof n.current == "string") {
      const r = n.current;
      if (r.startsWith("render-track-") && Pt().has(r))
        return r;
    }
    t = t.next;
  }
  return null;
}
function Wt() {
  return zn().trackedNames;
}
function Hr(e) {
  return Wt().get(e);
}
class Br {
  constructor() {
    z(this, "logs", /* @__PURE__ */ new Map());
  }
  /**
   * Add a log entry for a component GUID
   */
  addLog(t, n, r, ...o) {
    this.logs.has(t) || this.logs.set(t, []), this.logs.get(t).push({
      message: r,
      args: o,
      timestamp: Date.now(),
      level: n
    });
  }
  /**
   * Get and consume all logs for a component GUID
   * This removes the logs from the registry after returning them
   */
  consumeLogs(t) {
    const n = this.logs.get(t) || [];
    return this.logs.delete(t), n;
  }
  /**
   * Clear all logs (useful for cleanup)
   */
  clear() {
    this.logs.clear();
  }
  /**
   * Get the number of stored log entries across all components
   */
  getLogCount() {
    let t = 0;
    for (const n of this.logs.values())
      t += n.length;
    return t;
  }
}
const ze = new Br(), Pn = "(fn)";
function Be(e) {
  if (typeof e != "object" || e === null || Array.isArray(e))
    return e;
  const t = {};
  for (const [n, r] of Object.entries(e))
    t[n] = typeof r == "function" ? Pn : r;
  return t;
}
function qr(e) {
  if (typeof e != "object" || e === null || Array.isArray(e))
    return null;
  const t = Object.entries(e);
  if (t.length === 0)
    return { names: [], types: [] };
  const n = t.every(([i, s]) => typeof s == "function"), r = [], o = [];
  for (const [i, s] of t)
    r.push(i), n ? o.push("value") : o.push(typeof s == "function" ? "function" : "value");
  return { names: r, types: o };
}
function Kr(e, t, n, r) {
  const o = qr(n), i = Be(n);
  return {
    label: e,
    index: t,
    value: n,
    // Keep original for display (function identity preserved)
    prevValue: r,
    // Store previous value for ref-based matching
    normalizedValue: i,
    // Store normalized for comparison
    propertyMetadata: o ?? void 0
  };
}
const ye = /* @__PURE__ */ new Map(), Wn = /* @__PURE__ */ new Map();
function Jr(e, t) {
  const n = Kr(
    t.label,
    t.index,
    t.value,
    t.prevValue
  );
  ye.has(e) || ye.set(e, []), ye.get(e).push(n);
}
function Xr() {
  ye.clear();
}
function Yr(e) {
  ye.delete(e);
}
function Je(e, t) {
  const n = t.find((r) => r.index === e);
  return n ? `${n.label}.internal` : null;
}
function je(e) {
  return ye.get(e) || [];
}
function Gn(e) {
  return Wn.get(e) || [];
}
const Zr = {
  colors: {},
  prefixes: {}
}, Qr = {
  default: Zr
};
function eo(e) {
  switch (e) {
    case "off":
      return () => {
      };
    case "fatal":
    case "error":
      return console.error.bind(console);
    case "warn":
      return console.warn.bind(console);
    case "info":
      return console.info.bind(console);
    case "debug":
    case "log":
    case "verbose":
    case "trace":
      return console.log.bind(console);
  }
}
function ve(e, t, ...n) {
  try {
    eo(e)(t, ...n);
  } catch {
  }
}
function Ct(e, ...t) {
  try {
    console.group(e, ...t);
  } catch {
  }
}
function Un() {
  try {
    console.groupEnd();
  } catch {
  }
}
function to(e, t) {
  const n = String(t), r = n.match(/^(?:│\s\s)+/);
  if (!r)
    return [`%c${n}`, `color: ${e}`];
  const o = r[0], i = n.substring(o.length);
  return [`${o}%c${i}`, `color: ${e}`];
}
function Xe(e, t) {
  return `${e} (elapsed: ${t.toFixed(2)}ms)`;
}
function Ye(e, t) {
  e > 1e3 && console.warn(`⚠️ Task "${t}" took ${(e / 1e3).toFixed(2)}s to complete.`);
}
function no(e) {
  return "│  ".repeat(e > 0 ? e - 1 : 0);
}
function Ze(e, t, n, r, ...o) {
  if (r === "default")
    ve(t, e, ...o), Un();
  else {
    const s = `${no(n)}└─`;
    ve(t, `${s} ${e}`, ...o);
  }
  return n - 1;
}
function rt(e) {
  return "│  ".repeat(e);
}
function cn(e, t) {
  return t ? `${t} ${e}` : e;
}
function Et(e, t) {
  return t ? `${t} ${e}` : e;
}
function ro(e) {
  const n = (e.message === void 0 ? "" : String(e.message)).split(`
`), r = e.showName && e.name !== "" ? `[${e.name}] ` : "", o = e.prefix === "" ? "" : `${e.prefix} `;
  return n.map((i) => `${e.indent}${r}${o}${i}`).join(`
`);
}
function an(e, t, n, r, o) {
  if (t === -1)
    return console.warn('Cannot exit "unknown" - handle not found in stack'), {
      newGroupStack: n,
      newEnterStackLength: e.length,
      shouldReturn: !0,
      isNormalExit: !1
    };
  if (t === e.length - 1)
    return {
      newGroupStack: n,
      newEnterStackLength: e.length,
      shouldReturn: !1,
      isNormalExit: !0
    };
  const i = e[e.length - 1], s = e[t];
  if (!s) {
    const u = e.length === 0 ? "Cannot exit - stack is empty" : `Cannot exit - handle not found at index ${t}`;
    return console.warn(u), {
      newGroupStack: n,
      newEnterStackLength: e.length,
      shouldReturn: !0,
      isNormalExit: !1
    };
  }
  console.warn(`Expected to exit "${(i == null ? void 0 : i.label) ?? "unknown"}", but got "${s.label}". Unwinding stack...`);
  let c = n;
  for (let u = e.length - 1; u >= t; u--) {
    const f = e[u];
    f && o(f.level) && (c = r(f, c));
  }
  return {
    newGroupStack: c,
    newEnterStackLength: t,
    shouldReturn: !1,
    isNormalExit: !1
  };
}
const ln = [
  "off",
  "fatal",
  "error",
  "warn",
  "log",
  "info",
  "debug",
  "verbose",
  "trace"
];
function fe(e, t) {
  const n = ln.indexOf(t);
  return ln.indexOf(e) <= n;
}
function oo(e, t, n, r, o, i, s, ...c) {
  const u = t.prefixes[e] || "", f = t.colors[e], l = n === "text" ? rt(r) : "", a = ro({
    indent: l,
    name: i,
    showName: s,
    prefix: u,
    message: o
  });
  if (!f) {
    ve(e, a, ...c);
    return;
  }
  const [d, g] = to(f, a);
  ve(e, d, g, ...c);
}
function Ce(e, t, n) {
  return n ? `[${t}] ${e}` : e;
}
function io(e) {
  let t = "log", n = Qr.default, r = "default", o = !0, i = 0;
  const s = [], c = /* @__PURE__ */ new WeakSet();
  function u(a) {
    return c.has(a);
  }
  function f(a) {
    for (let d = a; d < s.length; d++) {
      const g = s[d];
      g && c.delete(g);
    }
  }
  const l = (a, d, ...g) => {
    fe(a, t) && oo(a, n, r, i, d, e, o, ...g);
  };
  return {
    setLogLevel(a) {
      t = a;
    },
    setTheme(a) {
      n = a;
    },
    setGroupMode(a) {
      r = a;
    },
    setShowName(a) {
      o = a;
    },
    fatal(a, ...d) {
      l("fatal", a, ...d);
    },
    error(a, ...d) {
      l("error", a, ...d);
    },
    warn(a, ...d) {
      l("warn", a, ...d);
    },
    log(a, ...d) {
      l("log", a, ...d);
    },
    info(a, ...d) {
      l("info", a, ...d);
    },
    debug(a, ...d) {
      l("debug", a, ...d);
    },
    verbose(a, ...d) {
      l("verbose", a, ...d);
    },
    trace(a, ...d) {
      l("trace", a, ...d);
    },
    group(a) {
      if (fe("log", t)) {
        const d = Ce(a, e, o);
        if (r === "default")
          Ct(typeof d == "string" || d === void 0 ? d : String(d));
        else {
          const m = `${rt(i)}├─`;
          ve("log", `${m} ${d}`);
        }
        i++;
      }
    },
    groupEnd() {
      fe("log", t) && i > 0 && (i--, r === "default" && Un());
    },
    enter(a, ...d) {
      const g = "trace", m = {
        label: a,
        startTime: performance.now(),
        level: g,
        optionalParams: d.length > 0 ? d : void 0
      };
      if (fe(g, t)) {
        const p = n.prefixes.enter || "", $ = cn(a, p), T = Ce($, e, o);
        if (r === "default")
          Ct(typeof T == "string" || T === void 0 ? T : String(T), ...d);
        else {
          const y = `${rt(i)}├─`;
          ve(g, `${y} ${T}`, ...d);
        }
        c.add(m), i++;
      }
      return s.push(m), m;
    },
    exit(a, ...d) {
      const g = d.length > 0 ? d : a.optionalParams || [], m = s.indexOf(a), p = an(s, m, i, ($, T) => {
        if (!u($))
          return c.delete($), T;
        const b = performance.now() - $.startTime, y = Xe($.label, b), C = Et(y, n.prefixes.exit || ""), L = Ce(C, e, o);
        Ye(b, $.label);
        const N = Ze(typeof L == "string" ? L : String(L), $.level, T, r, ...g);
        return c.delete($), N;
      }, ($) => fe($, t));
      if (!p.shouldReturn)
        if (!p.isNormalExit)
          f(p.newEnterStackLength), i = p.newGroupStack, s.length = p.newEnterStackLength;
        else {
          if (s.pop(), u(a) && fe(a.level, t)) {
            const $ = performance.now() - a.startTime, T = Xe(a.label, $), b = Et(T, n.prefixes.exit || ""), y = Ce(b, e, o);
            Ye($, a.label), i = Ze(typeof y == "string" ? y : String(y), a.level, i, r, ...g);
          }
          c.delete(a);
        }
    },
    enterStyled(a, d, ...g) {
      const m = "trace", p = {
        label: d,
        rawLabel: a,
        startTime: performance.now(),
        level: m,
        optionalParams: g.length > 0 ? g : void 0
      };
      if (fe(m, t)) {
        const $ = n.prefixes.enter || "", T = cn(d, $), b = Ce(T, e, o);
        if (r === "default")
          Ct(typeof b == "string" || b === void 0 ? b : String(b), ...g);
        else {
          const C = `${rt(i)}├─`;
          ve(m, `${C} ${b}`, ...g);
        }
        c.add(p), i++;
      }
      return s.push(p), p;
    },
    exitStyled(a, d, ...g) {
      const m = g.length > 0 ? g : a.optionalParams || [], p = s.indexOf(a), $ = an(s, p, i, (T, b) => {
        if (!u(T))
          return c.delete(T), b;
        const y = performance.now() - T.startTime, C = Xe(T.label, y), L = Et(C, n.prefixes.exit || ""), N = Ce(L, e, o);
        Ye(y, T.label);
        const te = Ze(typeof N == "string" ? N : String(N), T.level, b, r, ...m);
        return c.delete(T), te;
      }, (T) => fe(T, t));
      if (!$.shouldReturn)
        if (!$.isNormalExit)
          f($.newEnterStackLength), i = $.newGroupStack, s.length = $.newEnterStackLength;
        else {
          if (s.pop(), u(a) && fe(a.level, t)) {
            const T = performance.now() - a.startTime, b = Xe(d, T), y = Ce(b, e, o);
            Ye(T, a.rawLabel), i = Ze(typeof y == "string" ? y : String(y), a.level, i, r, ...m);
          }
          c.delete(a);
        }
    }
  };
}
const wt = /* @__PURE__ */ new Map();
function so(e) {
  return wt.has(e) || wt.set(e, io(e)), wt.get(e);
}
const h = so("auto-tracer");
h.setShowName(!0);
h.setLogLevel("error");
function Hn(e) {
  e && h.setLogLevel(e);
}
function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var At = { exports: {} };
(function(e, t) {
  const { hasOwnProperty: n } = Object.prototype, r = T();
  r.configure = T, r.stringify = r, r.default = r, t.stringify = r, t.configure = T, e.exports = r;
  const o = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]/;
  function i(b) {
    return b.length < 5e3 && !o.test(b) ? `"${b}"` : JSON.stringify(b);
  }
  function s(b, y) {
    if (b.length > 200 || y)
      return b.sort(y);
    for (let C = 1; C < b.length; C++) {
      const L = b[C];
      let N = C;
      for (; N !== 0 && b[N - 1] > L; )
        b[N] = b[N - 1], N--;
      b[N] = L;
    }
    return b;
  }
  const c = Object.getOwnPropertyDescriptor(
    Object.getPrototypeOf(
      Object.getPrototypeOf(
        new Int8Array()
      )
    ),
    Symbol.toStringTag
  ).get;
  function u(b) {
    return c.call(b) !== void 0 && b.length !== 0;
  }
  function f(b, y, C) {
    b.length < C && (C = b.length);
    const L = y === "," ? "" : " ";
    let N = `"0":${L}${b[0]}`;
    for (let te = 1; te < C; te++)
      N += `${y}"${te}":${L}${b[te]}`;
    return N;
  }
  function l(b) {
    if (n.call(b, "circularValue")) {
      const y = b.circularValue;
      if (typeof y == "string")
        return `"${y}"`;
      if (y == null)
        return y;
      if (y === Error || y === TypeError)
        return {
          toString() {
            throw new TypeError("Converting circular structure to JSON");
          }
        };
      throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined');
    }
    return '"[Circular]"';
  }
  function a(b) {
    let y;
    if (n.call(b, "deterministic") && (y = b.deterministic, typeof y != "boolean" && typeof y != "function"))
      throw new TypeError('The "deterministic" argument must be of type boolean or comparator function');
    return y === void 0 ? !0 : y;
  }
  function d(b, y) {
    let C;
    if (n.call(b, y) && (C = b[y], typeof C != "boolean"))
      throw new TypeError(`The "${y}" argument must be of type boolean`);
    return C === void 0 ? !0 : C;
  }
  function g(b, y) {
    let C;
    if (n.call(b, y)) {
      if (C = b[y], typeof C != "number")
        throw new TypeError(`The "${y}" argument must be of type number`);
      if (!Number.isInteger(C))
        throw new TypeError(`The "${y}" argument must be an integer`);
      if (C < 1)
        throw new RangeError(`The "${y}" argument must be >= 1`);
    }
    return C === void 0 ? 1 / 0 : C;
  }
  function m(b) {
    return b === 1 ? "1 item" : `${b} items`;
  }
  function p(b) {
    const y = /* @__PURE__ */ new Set();
    for (const C of b)
      (typeof C == "string" || typeof C == "number") && y.add(String(C));
    return y;
  }
  function $(b) {
    if (n.call(b, "strict")) {
      const y = b.strict;
      if (typeof y != "boolean")
        throw new TypeError('The "strict" argument must be of type boolean');
      if (y)
        return (C) => {
          let L = `Object can not safely be stringified. Received type ${typeof C}`;
          throw typeof C != "function" && (L += ` (${C.toString()})`), new Error(L);
        };
    }
  }
  function T(b) {
    b = { ...b };
    const y = $(b);
    y && (b.bigint === void 0 && (b.bigint = !1), "circularValue" in b || (b.circularValue = Error));
    const C = l(b), L = d(b, "bigint"), N = a(b), te = typeof N == "function" ? N : void 0, ue = g(b, "maximumDepth"), F = g(b, "maximumBreadth");
    function xe(U, S, E, R, v, k) {
      let w = S[U];
      switch (typeof w == "object" && w !== null && typeof w.toJSON == "function" && (w = w.toJSON(U)), w = R.call(S, U, w), typeof w) {
        case "string":
          return i(w);
        case "object": {
          if (w === null)
            return "null";
          if (E.indexOf(w) !== -1)
            return C;
          let O = "", V = ",";
          const _ = k;
          if (Array.isArray(w)) {
            if (w.length === 0)
              return "[]";
            if (ue < E.length + 1)
              return '"[Array]"';
            E.push(w), v !== "" && (k += v, O += `
${k}`, V = `,
${k}`);
            const X = Math.min(w.length, F);
            let ie = 0;
            for (; ie < X - 1; ie++) {
              const Ke = xe(String(ie), w, E, R, v, k);
              O += Ke !== void 0 ? Ke : "null", O += V;
            }
            const se = xe(String(ie), w, E, R, v, k);
            if (O += se !== void 0 ? se : "null", w.length - 1 > F) {
              const Ke = w.length - F - 1;
              O += `${V}"... ${m(Ke)} not stringified"`;
            }
            return v !== "" && (O += `
${_}`), E.pop(), `[${O}]`;
          }
          let j = Object.keys(w);
          const W = j.length;
          if (W === 0)
            return "{}";
          if (ue < E.length + 1)
            return '"[Object]"';
          let A = "", q = "";
          v !== "" && (k += v, V = `,
${k}`, A = " ");
          const oe = Math.min(W, F);
          N && !u(w) && (j = s(j, te)), E.push(w);
          for (let X = 0; X < oe; X++) {
            const ie = j[X], se = xe(ie, w, E, R, v, k);
            se !== void 0 && (O += `${q}${i(ie)}:${A}${se}`, q = V);
          }
          if (W > F) {
            const X = W - F;
            O += `${q}"...":${A}"${m(X)} not stringified"`, q = V;
          }
          return v !== "" && q.length > 1 && (O = `
${k}${O}
${_}`), E.pop(), `{${O}}`;
        }
        case "number":
          return isFinite(w) ? String(w) : y ? y(w) : "null";
        case "boolean":
          return w === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (L)
            return String(w);
        default:
          return y ? y(w) : void 0;
      }
    }
    function ke(U, S, E, R, v, k) {
      switch (typeof S == "object" && S !== null && typeof S.toJSON == "function" && (S = S.toJSON(U)), typeof S) {
        case "string":
          return i(S);
        case "object": {
          if (S === null)
            return "null";
          if (E.indexOf(S) !== -1)
            return C;
          const w = k;
          let O = "", V = ",";
          if (Array.isArray(S)) {
            if (S.length === 0)
              return "[]";
            if (ue < E.length + 1)
              return '"[Array]"';
            E.push(S), v !== "" && (k += v, O += `
${k}`, V = `,
${k}`);
            const W = Math.min(S.length, F);
            let A = 0;
            for (; A < W - 1; A++) {
              const oe = ke(String(A), S[A], E, R, v, k);
              O += oe !== void 0 ? oe : "null", O += V;
            }
            const q = ke(String(A), S[A], E, R, v, k);
            if (O += q !== void 0 ? q : "null", S.length - 1 > F) {
              const oe = S.length - F - 1;
              O += `${V}"... ${m(oe)} not stringified"`;
            }
            return v !== "" && (O += `
${w}`), E.pop(), `[${O}]`;
          }
          E.push(S);
          let _ = "";
          v !== "" && (k += v, V = `,
${k}`, _ = " ");
          let j = "";
          for (const W of R) {
            const A = ke(W, S[W], E, R, v, k);
            A !== void 0 && (O += `${j}${i(W)}:${_}${A}`, j = V);
          }
          return v !== "" && j.length > 1 && (O = `
${k}${O}
${w}`), E.pop(), `{${O}}`;
        }
        case "number":
          return isFinite(S) ? String(S) : y ? y(S) : "null";
        case "boolean":
          return S === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (L)
            return String(S);
        default:
          return y ? y(S) : void 0;
      }
    }
    function $e(U, S, E, R, v) {
      switch (typeof S) {
        case "string":
          return i(S);
        case "object": {
          if (S === null)
            return "null";
          if (typeof S.toJSON == "function") {
            if (S = S.toJSON(U), typeof S != "object")
              return $e(U, S, E, R, v);
            if (S === null)
              return "null";
          }
          if (E.indexOf(S) !== -1)
            return C;
          const k = v;
          if (Array.isArray(S)) {
            if (S.length === 0)
              return "[]";
            if (ue < E.length + 1)
              return '"[Array]"';
            E.push(S), v += R;
            let A = `
${v}`;
            const q = `,
${v}`, oe = Math.min(S.length, F);
            let X = 0;
            for (; X < oe - 1; X++) {
              const se = $e(String(X), S[X], E, R, v);
              A += se !== void 0 ? se : "null", A += q;
            }
            const ie = $e(String(X), S[X], E, R, v);
            if (A += ie !== void 0 ? ie : "null", S.length - 1 > F) {
              const se = S.length - F - 1;
              A += `${q}"... ${m(se)} not stringified"`;
            }
            return A += `
${k}`, E.pop(), `[${A}]`;
          }
          let w = Object.keys(S);
          const O = w.length;
          if (O === 0)
            return "{}";
          if (ue < E.length + 1)
            return '"[Object]"';
          v += R;
          const V = `,
${v}`;
          let _ = "", j = "", W = Math.min(O, F);
          u(S) && (_ += f(S, V, F), w = w.slice(S.length), W -= S.length, j = V), N && (w = s(w, te)), E.push(S);
          for (let A = 0; A < W; A++) {
            const q = w[A], oe = $e(q, S[q], E, R, v);
            oe !== void 0 && (_ += `${j}${i(q)}: ${oe}`, j = V);
          }
          if (O > F) {
            const A = O - F;
            _ += `${j}"...": "${m(A)} not stringified"`, j = V;
          }
          return j !== "" && (_ = `
${v}${_}
${k}`), E.pop(), `{${_}}`;
        }
        case "number":
          return isFinite(S) ? String(S) : y ? y(S) : "null";
        case "boolean":
          return S === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (L)
            return String(S);
        default:
          return y ? y(S) : void 0;
      }
    }
    function Me(U, S, E) {
      switch (typeof S) {
        case "string":
          return i(S);
        case "object": {
          if (S === null)
            return "null";
          if (typeof S.toJSON == "function") {
            if (S = S.toJSON(U), typeof S != "object")
              return Me(U, S, E);
            if (S === null)
              return "null";
          }
          if (E.indexOf(S) !== -1)
            return C;
          let R = "";
          const v = S.length !== void 0;
          if (v && Array.isArray(S)) {
            if (S.length === 0)
              return "[]";
            if (ue < E.length + 1)
              return '"[Array]"';
            E.push(S);
            const _ = Math.min(S.length, F);
            let j = 0;
            for (; j < _ - 1; j++) {
              const A = Me(String(j), S[j], E);
              R += A !== void 0 ? A : "null", R += ",";
            }
            const W = Me(String(j), S[j], E);
            if (R += W !== void 0 ? W : "null", S.length - 1 > F) {
              const A = S.length - F - 1;
              R += `,"... ${m(A)} not stringified"`;
            }
            return E.pop(), `[${R}]`;
          }
          let k = Object.keys(S);
          const w = k.length;
          if (w === 0)
            return "{}";
          if (ue < E.length + 1)
            return '"[Object]"';
          let O = "", V = Math.min(w, F);
          v && u(S) && (R += f(S, ",", F), k = k.slice(S.length), V -= S.length, O = ","), N && (k = s(k, te)), E.push(S);
          for (let _ = 0; _ < V; _++) {
            const j = k[_], W = Me(j, S[j], E);
            W !== void 0 && (R += `${O}${i(j)}:${W}`, O = ",");
          }
          if (w > F) {
            const _ = w - F;
            R += `${O}"...":"${m(_)} not stringified"`;
          }
          return E.pop(), `{${R}}`;
        }
        case "number":
          return isFinite(S) ? String(S) : y ? y(S) : "null";
        case "boolean":
          return S === !0 ? "true" : "false";
        case "undefined":
          return;
        case "bigint":
          if (L)
            return String(S);
        default:
          return y ? y(S) : void 0;
      }
    }
    function $t(U, S, E) {
      if (arguments.length > 1) {
        let R = "";
        if (typeof E == "number" ? R = " ".repeat(Math.min(E, 10)) : typeof E == "string" && (R = E.slice(0, 10)), S != null) {
          if (typeof S == "function")
            return xe("", { "": U }, [], S, R, "");
          if (Array.isArray(S))
            return ke("", U, [], p(S), R, "");
        }
        if (R.length !== 0)
          return $e("", U, [], R, "");
      }
      return Me("", U, []);
    }
    return $t;
  }
})(At, At.exports);
var co = At.exports;
const Gt = /* @__PURE__ */ Bn(co);
Gt.configure;
const un = /* @__PURE__ */ new WeakMap();
let ao = 1;
function We(e) {
  const t = un.get(e);
  if (t !== void 0)
    return t;
  const n = ao++;
  return un.set(e, n), n;
}
function lo(e, t) {
  return typeof e != "object" || e === null ? null : t.has(e) ? "[Circular]" : null;
}
const uo = 10;
function fo(e) {
  return e > uo ? "[MaxDepth]" : null;
}
const go = 1e3;
function ho(e) {
  return e.count > go ? "[MaxNodes]" : null;
}
function po(e) {
  var o;
  if (typeof e != "object" || e === null)
    return null;
  const t = Object.getPrototypeOf(e);
  if (t === Object.prototype || t === Array.prototype || t === null)
    return null;
  const n = ((o = e.constructor) == null ? void 0 : o.name) || "Object";
  return typeof Element < "u" && e instanceof Element || typeof HTMLElement < "u" && e instanceof HTMLElement || typeof Node < "u" && e instanceof Node || n.includes("HTML") || n.includes("Element") || n === "Window" || n === "Document" ? `[${n}]` : null;
}
function mo(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.tag != "number")
    return null;
  const n = "stateNode" in t, r = "alternate" in t, o = "elementType" in t, i = "memoizedProps" in t, s = "memoizedState" in t, c = "return" in t, u = "child" in t;
  let f = 0;
  n && f++, r && f++, o && f++, i && f++, s && f++;
  const l = c && u;
  return f >= 2 && l ? "[FiberNode]" : null;
}
function bo(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  return t.$$typeof && typeof t.$$typeof == "symbol" && t.$$typeof.toString() === "Symbol(react.element)" ? "[ReactElement]" : null;
}
function it(e, t = /* @__PURE__ */ new WeakSet(), n = 0, r = { count: 0 }) {
  const o = h.enter(
    "normalizeValueDeepWithIDs",
    e,
    n,
    r
  );
  try {
    const i = fo(n);
    if (i !== null)
      return i;
    r.count++;
    const s = ho(r);
    if (s !== null)
      return s;
    if (typeof e == "function")
      return `(fn:${We(e)})`;
    if (typeof e != "object" || e === null)
      return e;
    const c = lo(e, t);
    if (c !== null)
      return c;
    const u = bo(e);
    if (u !== null)
      return u;
    const f = mo(e);
    if (f !== null)
      return f;
    const l = po(e);
    if (l !== null)
      return l;
    const a = Object.getPrototypeOf(e);
    if (a !== Object.prototype && a !== Array.prototype && a !== null)
      return e;
    if (t.add(e), Array.isArray(e))
      return e.map((p) => it(p, t, n + 1, r));
    const d = {}, g = Object.keys(e);
    for (const m of g)
      try {
        const p = e[m];
        d[m] = it(
          p,
          t,
          n + 1,
          r
        );
      } catch {
        d[m] = "[Error]";
      }
    return d;
  } finally {
    h.exit(o);
  }
}
const qn = {
  // outputMode: "devtools", // Startup config only; intentionally unset by default to avoid overriding an existing global outputMode.
  enabled: !1,
  // Start dormant by default; opt into active startup explicitly
  detectIdenticalValueChanges: !0,
  includeReconciled: "never",
  includeSkipped: "never",
  includeMount: "never",
  includeRendered: "never",
  filterEmptyNodes: "all",
  // No empty node filtering by default (backward compatible)
  includeNonTrackedBranches: !1,
  // Only show tracked components and their parent chain by default
  maxFiberDepth: 500,
  // Maximum fiber traversal depth
  skippedObjectProps: [],
  // Skip specific props for specific object types
  internalLogLevel: "error",
  // Silent by default - only show errors
  showFlags: !1,
  functionCache: !1,
  // Disabled by default for production safety
  functionCacheLogging: !1,
  // Disabled by default (requires functionCache: true)
  // Trigger configuration
  startTriggerFunctionName: null,
  // No automatic start trigger by default
  endTriggerFunctionName: null,
  // No automatic end trigger by default
  endTriggerMode: "on-exit",
  // Stop after end trigger completes (default)
  triggerRearmMode: "once",
  // Allow repeated trigger sequences (default)
  // Default styling (matching comments in ReactTracerOptions.ts)
  colors: {
    definitiveRender: {
      lightMode: { text: "#0044ff", bold: !0 },
      // Blue, Bold
      darkMode: { text: "#4fd6ff", bold: !0 },
      // Lighter blue
      icon: "⚡"
    },
    propInitial: {
      icon: void 0,
      // Initial prop value
      lightMode: { text: "#c900bf", italic: !0 },
      // Magenta, Italic
      darkMode: { text: "#ff77e8", italic: !0 }
      // Lighter magenta for dark mode
    },
    propChange: {
      icon: void 0,
      // Prop changed
      lightMode: { text: "#c900bf" },
      // Magenta
      darkMode: { text: "#ff77e8" }
      // Lighter magenta for dark mode
    },
    stateInitial: {
      icon: void 0,
      // Initial state value
      lightMode: { text: "#df7f02", italic: !0 },
      // Orange, Italic
      darkMode: { text: "#ffcf33", italic: !0 }
      // Lighter orange for dark mode
    },
    stateChange: {
      icon: void 0,
      // State changed
      lightMode: { text: "#df7f02" },
      // Orange
      darkMode: { text: "#ffcf33" }
      // Lighter orange for dark mode
    },
    logStatements: {
      icon: void 0,
      // Log statements
      lightMode: { text: "#00aa00" },
      // Green
      darkMode: { text: "#4ade80" }
      // Lighter green for dark mode
    },
    warnStatements: {
      icon: "⚠️",
      // Warning statements
      lightMode: { text: "#000000", background: "#fbf6d7" },
      // Black on light yellow
      darkMode: { text: "#f9f2a3", background: "#3f3c28" }
      // Light yellow on dark yellow-brown
    },
    errorStatements: {
      icon: "❌",
      // Error statements
      lightMode: { text: "#000000", background: "#f6eceb" },
      // Black on light red
      darkMode: { text: "#f0dfd2", background: "#473635" }
      // Light red on dark red-brown
    },
    reconciled: {
      lightMode: { text: "#9ca3af" },
      // Gray-500
      darkMode: { text: "#9ca3af" },
      // Gray-500
      icon: void 0
      // Reconciled/reused
    },
    skipped: {
      lightMode: { text: "#8e8e8e" },
      // Gray-500
      darkMode: { text: "#9ca3af" },
      // Gray-500
      icon: void 0
      // Skipped
    },
    // Distinct identical state value warning styling (icon only; inherit rest)
    identicalStateValueWarning: {
      icon: "⚠️",
      // Warning icon
      lightMode: { text: "#df7f02", bold: !0 },
      // Orange
      darkMode: { text: "#ffcf33", bold: !0 }
      // Lighter orange for dark mode
    },
    // Distinct identical prop value warning styling (icon only; inherit rest)
    identicalPropValueWarning: {
      icon: "⚠️",
      // Warning icon
      lightMode: { text: "#c900bf", bold: !0 },
      // Magenta
      darkMode: { text: "#ff77e8", bold: !0 }
      // Lighter magenta for dark mode
    },
    other: {
      lightMode: { text: "#000000" },
      // Black
      darkMode: { text: "#ffffff" },
      // White
      icon: void 0
      // Other/unknown
    }
  }
};
function yo(e) {
  return e === "devtools" ? "group" : "lineart";
}
function So(e) {
  return e === "devtools" ? "as-is" : "serialized";
}
function Kn(e) {
  const t = yo(e), n = So(e);
  return {
    treeRenderingMode: t,
    valueRenderingMode: n
  };
}
let Te = 0, Ut = 0, Ht = 0;
function To() {
  try {
    return typeof window > "u" ? !1 : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return !1;
  }
}
function $o() {
  const e = globalThis.__autoTracerInternal, t = e == null ? void 0 : e.outputMode;
  return t === "devtools" || t === "copy-paste" ? t : "devtools";
}
function Jn() {
  return globalThis.__autoTracerInternal || (globalThis.__autoTracerInternal = {
    outputMode: "devtools",
    subscribers: []
  }), globalThis.__autoTracerInternal.sharedTracerState || (globalThis.__autoTracerInternal.sharedTracerState = {
    traceOptions: {
      ...qn,
      ...Kn($o())
    }
  }), globalThis.__autoTracerInternal.sharedTracerState;
}
function x() {
  return Jn().traceOptions;
}
x();
function Nt(e) {
  const t = Jn();
  t.traceOptions = e;
}
function Xn(e) {
  h.debug(
    "ReactTracer options updated:",
    JSON.stringify(e, null, 2)
  );
}
function Mo() {
  Te++;
}
function Co() {
  const e = Te - Ut - 1;
  return {
    cycleNumber: Te,
    filteredCount: e > 0 ? e : 0
  };
}
function Eo() {
  Ut = Te;
}
function wo() {
  Te = 0, Ut = 0, Ht = 0;
}
function fn() {
  Ht = Te;
}
function vo() {
  return Te - Ht;
}
function Oo() {
  return Te;
}
const st = /* @__PURE__ */ new Map();
function Ro(e, t) {
  let n = e;
  for (const r of t)
    if (!(n instanceof Map) || (n = n.get(r), n === void 0)) return;
  return n instanceof Map ? void 0 : n;
}
function xo(e, t, n) {
  let r = e;
  for (let o = 0; o < t.length - 1; o++) {
    const i = t[o];
    let s = r.get(i);
    s instanceof Map || (s = /* @__PURE__ */ new Map(), r.set(i, s)), r = s;
  }
  r.set(t[t.length - 1], n);
}
function Z(e, t, n) {
  let r = st.get(n);
  return r || (r = /* @__PURE__ */ new Map(), st.set(
    n,
    r
  )), (...o) => {
    if (!x().functionCache)
      return n(...o);
    const i = Ro(r, o);
    if (i) {
      if (x().functionCacheLogging && i.meta) {
        const l = i.meta.callerAccess.get(t) || 0;
        i.meta.callerAccess.set(t, l + 1);
      }
      return i.value;
    }
    const s = x().functionCacheLogging ? performance.now() : 0, c = n(...o), u = /* @__PURE__ */ new Map();
    u.set(t, 1);
    const f = {
      value: c,
      meta: x().functionCacheLogging ? {
        functionName: e,
        args: o,
        firstComputeTimeMs: performance.now() - s,
        callerAccess: u
      } : void 0
    };
    return xo(r, o, f), c;
  };
}
const ko = Z(
  "normalizeValueDeepWithIDs",
  "stringify",
  it
);
function mt(e) {
  const t = h.enter("stringify");
  try {
    if (typeof e == "function")
      return `(fn:${We(e)})`;
    if (typeof e != "object" || e === null)
      return String(e);
    const n = ko(e);
    return Gt.configure({
      circularValue: "[Circular]"
    })(n) ?? "[Unserializable]";
  } catch (n) {
    try {
      return `[Error serializing: ${n instanceof Error ? n.message : String(n)}]`;
    } catch {
      return "[Unserializable]";
    }
  } finally {
    h.exit(t);
  }
}
const Ao = Z(
  "normalizeValue",
  "toComparableString",
  Be
), No = Z(
  "stringify",
  "toComparableString",
  mt
);
function bt(e) {
  const t = h.enter("toComparableString"), n = Ao(e), r = No(n);
  return h.exit(t), r;
}
function dn(e, t, n) {
  const r = ye.get(e);
  if (!r)
    return;
  const o = r.find((i) => i.label === t);
  o && (o.normalizedValue = n);
}
function Yn(e) {
  if (e === null || typeof e != "object")
    return !1;
  if ("$$typeof" in e || "stateNode" in e || "containerInfo" in e || "tag" in e)
    return !0;
  try {
    let t = 0;
    return JSON.stringify(e, (n, r) => {
      if (t++, t > 100)
        throw new Error("Max depth exceeded");
      return r;
    }), !1;
  } catch {
    return !0;
  }
}
function Lo(e, t) {
  return e.filter((n) => {
    if (Yn(n.value))
      return !1;
    try {
      return bt(n.value) === t;
    } catch {
      return !1;
    }
  });
}
const jo = Z(
  "normalizeValue",
  "checkKeyOrderMatches",
  Be
);
function Fo(e, t) {
  if (typeof e != "object" || e === null || typeof t != "object" || t === null || Array.isArray(e) || Array.isArray(t))
    return !0;
  const n = Object.keys(e), r = jo(t), o = Object.keys(r);
  return n.length === o.length && n.every((i, s) => i === o[s]);
}
const Io = Z("stringify", "matchUniqueValue", mt), Do = Z(
  "toComparableString",
  "matchUniqueValue",
  bt
), Vo = Z(
  "checkKeyOrderMatches",
  "matchUniqueValue",
  Fo
);
function _o(e, t) {
  const n = h.enter("matchUniqueValue"), r = Do(t), o = e.find((i) => Io(i.normalizedValue) !== r ? !1 : Vo(i.normalizedValue, t));
  return h.exit(n), o ?? null;
}
function zo(e, t, n) {
  if (!t || t.names.length !== t.types.length)
    return {
      success: !1,
      value: null,
      error: "invalid-metadata"
    };
  const r = {};
  let o = 0;
  for (let i = 0; i < t.names.length; i++) {
    const s = t.names[i], c = t.types[i];
    if (s === void 0 || c === void 0)
      return {
        success: !1,
        value: null,
        error: "invalid-metadata"
      };
    if (c === "function")
      r[s] = Pn;
    else {
      const u = e + o, f = n.find((l) => l.index === u);
      if (!f)
        return {
          success: !1,
          value: null,
          error: "insufficient-hooks"
        };
      r[s] = f.value, o++;
    }
  }
  return {
    success: !0,
    value: r
  };
}
function gn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e) && Object.prototype.toString.call(e) === "[object Object]";
}
function Po(e, t) {
  if (!gn(e) || !gn(t))
    return { success: !1, value: null, error: "invalid-input" };
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return { success: !1, value: null, error: "structure-mismatch" };
  for (let i = 0; i < n.length; i++)
    if (n[i] !== r[i])
      return { success: !1, value: null, error: "structure-mismatch" };
  const o = {};
  for (const i of n)
    o[i] = t[i];
  return { success: !0, value: o };
}
const hn = Z(
  "toComparableString",
  "tryStructuralMatch",
  bt
), pn = Z(
  "normalizeValue",
  "tryStructuralMatch",
  Be
);
function Zn(e, t, n, r) {
  const o = pn(n);
  for (const i of e) {
    if (i.index !== t || !i.propertyMetadata)
      continue;
    if ((typeof o != "object" || o === null) && typeof i.normalizedValue == "object" && i.normalizedValue !== null) {
      const l = i.normalizedValue, a = hn(o), d = Object.entries(l).find(
        ([g, m]) => hn(pn(m)) === a
      );
      if (d)
        return {
          success: !0,
          label: `${i.label}.${d[0]}`,
          updatedNormalizedValue: null
        };
      continue;
    }
    if (typeof o == "object" && o !== null && typeof i.normalizedValue == "object" && i.normalizedValue !== null) {
      const l = Object.keys(
        i.normalizedValue
      ), a = Object.keys(
        o
      );
      if (l.length === a.length && l.every((d, g) => d === a[g]))
        return {
          success: !0,
          label: i.label,
          updatedNormalizedValue: o
        };
    }
    const s = r.map((l) => ({
      index: l.index,
      value: l.value
    })), c = zo(
      t,
      i.propertyMetadata,
      s
    );
    if (!c.success)
      continue;
    const u = Be(c.value);
    if (typeof u == "object" && u !== null && typeof o == "object" && o !== null) {
      const l = Object.keys(
        u
      ), a = Object.keys(
        o
      );
      if (l.length !== a.length || !l.every((d, g) => d === a[g]))
        continue;
    }
    if (Po(
      i.normalizedValue,
      u
    ).success)
      return {
        success: !0,
        label: i.label,
        updatedNormalizedValue: u
      };
  }
  return {
    success: !1,
    label: null,
    updatedNormalizedValue: null
  };
}
const Wo = Z(
  "matchUniqueValue",
  "tryUniqueValueMatch",
  _o
);
function Go(e, t, n, r) {
  const o = Wo(e, n);
  return o != null && o.label ? {
    success: !0,
    label: o.label,
    updatedNormalizedValue: null
  } : Zn(e, t, n, r);
}
function Uo(e, t, n) {
  if (e.length !== t.length)
    return null;
  const r = [...t].sort((s, c) => s.index - c.index), o = [...e].sort((s, c) => s.index - c.index), i = r.findIndex((s) => s.index === n);
  return o[i] ?? null;
}
function Ho(e, t, n) {
  const r = [...e].sort((c, u) => c.index - u.index), o = [...t].sort((c, u) => c.index - u.index), i = o.findIndex((c) => c.index === n);
  return r.filter((c, u) => {
    const f = u, l = r.length - u - 1;
    return i >= f && o.length - i - 1 >= l;
  });
}
function Bo(e, t, n, r, o, i) {
  const s = e.filter((l) => mt(l.normalizedValue) === r), c = Uo(s, o, t);
  if (c)
    return {
      success: !0,
      label: c.label,
      updatedNormalizedValue: null
    };
  const u = Ho(
    s,
    o,
    t
  );
  return u.length === 0 ? Zn(e, t, n, i) : {
    success: !0,
    label: [...[...u].sort((l, a) => l.index - a.index).map((l) => l.label), "unknown"].join(" | "),
    updatedNormalizedValue: null
  };
}
const qo = Z(
  "toComparableString",
  "resolveHookLabel",
  bt
);
function Qn(e, t, n) {
  const r = h.enter(
    `resolveHookLabel: guid=${n.guid}, anchorIndex=${e}, anchorValue type=${typeof t}, allFiberAnchors.length=${n.allAnchors.length}`
  ), o = je(n.guid);
  if (Yn(t)) {
    const f = Je(e, o);
    return h.exit(r), f ?? "unknown";
  }
  let i;
  try {
    i = qo(t);
  } catch (f) {
    h.info(
      `resolveHookLabel: toComparableString FAILED - ${f}. Checking for index conflict`
    );
    const l = Je(e, o);
    return h.exit(r), l ?? "unknown";
  }
  const s = Lo(n.allAnchors, i);
  if (s.length === 1) {
    const f = Go(
      o,
      e,
      t,
      n.allAnchors
    );
    if (f.success && f.label)
      return f.updatedNormalizedValue !== null && dn(
        n.guid,
        f.label,
        f.updatedNormalizedValue
      ), h.exit(r), f.label;
    const l = Je(e, o);
    return h.exit(r), l ?? "unknown";
  }
  const c = Bo(
    o,
    e,
    t,
    i,
    s,
    n.allAnchors
  );
  if (c.success && c.label)
    return c.updatedNormalizedValue !== null && dn(
      n.guid,
      c.label,
      c.updatedNormalizedValue
    ), h.exit(r), c.label;
  const u = Je(e, o);
  return h.exit(r), u ?? "unknown";
}
function Ko(e) {
  const t = ye.get(e);
  t && Wn.set(e, t);
}
function Ie() {
  Pt().clear(), Wt().clear(), ze.clear(), Xr();
}
function Jo(e, t) {
  Pt().add(e), t && Wt().set(e, t);
}
function ct(...e) {
  try {
    typeof console < "u" && console.log && console.log(...e);
  } catch {
  }
}
function at(...e) {
  try {
    typeof console < "u" && console.group && console.group(...e);
  } catch {
  }
}
function Xo() {
  try {
    typeof console < "u" && console.groupEnd && console.groupEnd();
  } catch {
  }
}
function Yo(...e) {
  try {
    typeof console < "u" && console.warn && console.warn(...e);
  } catch {
  }
}
function Zo(e, t) {
  return e ? t.isDarkMode() ? e.darkMode || {} : e.lightMode || {} : {};
}
function Qo(e) {
  const t = [];
  return e.text && t.push(`color: ${e.text}`), e.background && t.push(`background: ${e.background}`), e.bold && t.push("font-weight: bold"), e.italic && t.push("font-style: italic"), t.join("; ");
}
function Q(e, t, n, r, o) {
  const i = o()[e], s = Zo(i, r), c = (i == null ? void 0 : i.icon) ?? "", u = Qo(s);
  return { formattedMessage: t === "before" && c ? `${c} ${n}` : t === "after" && c ? `${n} ${c}` : n, style: u };
}
function Bt(e, t, n, ...r) {
  n && n.length > 0 ? at(`${e}%c${t}`, n, ...r) : at(`${e}${t}`, ...r);
}
function ei(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "definitiveRender",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  Bt(e, o, i, ...r);
}
function ti(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "reconciled",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  Bt(e, o, i, ...r);
}
function ni(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "skipped",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  Bt(e, o, i, ...r);
}
function ri(e, t, n, r, ...o) {
  n ? ei(e, t, r, ...o) : at(`${e}${t}`, ...o);
}
function le(e, t, n, ...r) {
  n && n.length > 0 ? ct(`${e}%c${t}`, n, ...r) : ct(`${e}${t}`, ...r);
}
function oi(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "definitiveRender",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
function ii(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "errorStatements",
    "before",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
function si(e, t, n) {
  const { formattedMessage: r, style: o } = Q(
    "identicalPropValueWarning",
    "before",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, r, o);
}
function ci(e, t, n) {
  const { formattedMessage: r, style: o } = Q(
    "identicalStateValueWarning",
    "before",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, r, o);
}
function ai(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "logStatements",
    "before",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
function li(e, t, n, r, ...o) {
  const i = n ? "propInitial" : "propChange", { formattedMessage: s, style: c } = Q(
    i,
    "before",
    t,
    r.themeManager,
    r.getColors
  );
  le(e, s, c, ...o);
}
function ui(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "reconciled",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
function fi(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "skipped",
    "after",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
function di(e, t, n, r, ...o) {
  const i = n ? "stateInitial" : "stateChange", { formattedMessage: s, style: c } = Q(
    i,
    "before",
    t,
    r.themeManager,
    r.getColors
  );
  le(e, s, c, ...o);
}
function gi(e, t, n, r, ...o) {
  n ? oi(e, t, r, ...o) : ct(`${e}${t}`, ...o);
}
function hi(e, t, n, ...r) {
  const { formattedMessage: o, style: i } = Q(
    "warnStatements",
    "before",
    t,
    n.themeManager,
    n.getColors
  );
  le(e, o, i, ...r);
}
const ee = Object.freeze({
  themeManager: Object.freeze({
    isDarkMode: () => To()
  }),
  getColors: () => x().colors || {}
}), J = ct, er = at, lt = Xo, Ne = Yo;
function mn(e, t, n = !1, ...r) {
  li(e, t, n, ee, ...r);
}
function bn(e, t, n = !1, ...r) {
  di(e, t, n, ee, ...r);
}
function pi(e, t, ...n) {
  ai(e, t, ee, ...n);
}
function mi(e, t, ...n) {
  hi(e, t, ee, ...n);
}
function bi(e, t, ...n) {
  ii(e, t, ee, ...n);
}
function tr(e, t, ...n) {
  ui(e, t, ee, ...n);
}
function yi(e, t, ...n) {
  ti(e, t, ee, ...n);
}
function nr(e, t, ...n) {
  fi(e, t, ee, ...n);
}
function Si(e, t, ...n) {
  ni(e, t, ee, ...n);
}
function Ti(e, t) {
  ci(e, t, ee);
}
function $i(e, t) {
  si(e, t, ee);
}
function rr(e, t, n = !1, ...r) {
  gi(e, t, n, ee, ...r);
}
function Mi(e, t, n = !1, ...r) {
  ri(e, t, n, ee, ...r);
}
function Ci(e, t) {
  if (!e || typeof e != "object") return !1;
  const n = [e];
  for (; n.length > 0; ) {
    const r = n.pop();
    if (!r || typeof r != "object") continue;
    const o = r;
    if (o.elementType && t(r))
      return !0;
    o.sibling && n.push(o.sibling), o.child && n.push(o.child);
  }
  return !1;
}
function Ei(e) {
  var n;
  const t = [];
  try {
    if (!e || typeof e != "object")
      return t;
    let r = e.memoizedState, o = (n = e.alternate) == null ? void 0 : n.memoizedState, i = 0;
    const s = /* @__PURE__ */ new Set();
    for (; r && !s.has(r); ) {
      s.add(r);
      const c = r, u = o;
      if (c.queue) {
        const f = c.memoizedState, l = u == null ? void 0 : u.memoizedState, a = `state${i}`;
        t.push({
          name: a,
          value: f,
          prevValue: l,
          hook: c
        });
      }
      r = c.next, o = u == null ? void 0 : u.next, i++;
    }
  } catch (r) {
    Ne("ReactTracer: Error extracting useState values:", r);
  }
  return t;
}
function or(e) {
  if (!e) return null;
  if (typeof e == "function") {
    const t = e;
    return t.displayName || t.name || null;
  }
  if (typeof e == "object") {
    const t = e;
    return t.displayName || t.name || null;
  }
  return e.toString() || "Unknown";
}
function wi(e) {
  var r;
  const t = e.type;
  if ((r = t == null ? void 0 : t.render) != null && r.name)
    return t.render.name;
  if (t != null && t.type && typeof t.type == "function")
    return t.type.name || "Unknown";
  const n = e.elementType || e.type;
  return or(n) || "Unknown";
}
const vi = (
  /*                */
  1
), Oi = (
  /*                    */
  2
), Ri = (
  /*                       */
  4
), xi = {
  1: "PerformedWork",
  2: "Placement",
  4: "Update",
  16: "ChildDeletion",
  32: "ContentReset",
  64: "Callback/DidCapture",
  256: "ForceClientRender",
  512: "Ref",
  1024: "Hydrating/Snapshot",
  2048: "Passive",
  16384: "Visibility",
  32768: "StoreConsistency",
  33554432: "PlacementDEV",
  65536: "Incomplete",
  131072: "ShouldCapture",
  262144: "ForceClientRender",
  524288: "ForceUpdateForLegacySuspense",
  1048576: "PassiveUnmountPendingDev",
  2097152: "ScheduleRetry",
  4194304: "ChildDidSuspend",
  8388608: "DidSuspend"
};
function ir(e) {
  const t = [];
  for (const [n, r] of Object.entries(xi)) {
    const o = parseInt(n, 10);
    e & o && t.push(r);
  }
  return t;
}
function ki(e) {
  return !!(e & (vi | Ri | Oi));
}
function Ai(e, t) {
  return e ? "Mount" : ki(t ?? 0) ? "Rendering" : "Skipped";
}
const Ge = Symbol.for("react-tracer-state-marker");
function Ni(e) {
  if (!e)
    return [];
  const t = [];
  let n = e;
  for (; n; )
    n.queue !== null && n.queue !== void 0 && n.memoizedState !== Ge && t.push(n), n = n.next;
  return t;
}
function Li(e) {
  const t = Ni(e), n = t.map((r, o) => ({ index: o, value: r.memoizedState }));
  return { anchors: t, allAnchors: n };
}
function qe(e) {
  return [
    "selfBaseDuration",
    "treeBaseDuration",
    "actualDuration",
    "actualStartTime",
    "flags",
    "subtreeFlags",
    "lanes",
    "childLanes",
    "mode",
    "index",
    "key",
    "ref",
    "type",
    "elementType",
    "pendingProps",
    "memoizedProps",
    "memoizedState",
    "updateQueue",
    "alternate",
    "return",
    "child",
    "sibling",
    "stateNode",
    "tag",
    "dependencies"
  ].includes(e) || e.startsWith("_") || e.includes("react") || e.includes("React") || e.includes("Fiber");
}
function ji(e) {
  return e.filter(({ name: t, value: n }) => !qe(t) && n !== Ge);
}
function sr(e, t) {
  if (!e) return -1;
  for (let n = 0; n < t.length; n++)
    if (Object.is(t[n], e))
      return n;
  return -1;
}
function Fi(e, t) {
  const { anchors: n, allAnchors: r, trackingGUID: o } = t;
  h.debug("buildStateChanges: Resolving hook label (mount)"), h.debug("buildStateChanges: About to call anchors.indexOf(hook)"), h.debug(
    `buildStateChanges: hook type=${typeof e}, hook=${e ? "exists" : "null"}`
  ), h.debug(`buildStateChanges: anchors.length=${n.length}`);
  const i = sr(e, n);
  if (h.debug(`buildStateChanges: Got anchorIndex=${i}`), h.debug("buildStateChanges: About to validate hook structure"), !e || typeof e != "object")
    return h.debug(
      "buildStateChanges: GUARD FAILED - hook is not an object, skipping"
    ), `state${i}`;
  if (!("memoizedState" in e))
    return h.debug(
      "buildStateChanges: GUARD FAILED - hook missing memoizedState property, skipping"
    ), `state${i}`;
  h.debug(
    "buildStateChanges: Guard passed, accessing memoizedState"
  );
  const s = e.memoizedState;
  h.trace(
    `buildStateChanges: Got memoizedState, type=${typeof s}`
  ), h.trace(
    "buildStateChanges: About to call resolveHookLabel with:"
  ), h.trace(
    `  guid=${o}`,
    `anchorIndex=${i}`,
    `memoizedState type=${typeof s}`,
    `allAnchors.length=${r.length}`
  ), r.length > 0 && r[0] && h.trace(
    "  allAnchors[0]=",
    r[0],
    `has index?=${"index" in r[0]}`,
    `has value?=${"value" in r[0]}`
  );
  const c = Qn(
    i,
    s,
    { guid: o ?? "", allAnchors: r }
  );
  return h.debug(`buildStateChanges: Resolved to "${c}"`), c;
}
function Ii(e, t) {
  return h.debug(
    "buildStateChanges: Getting unmatched labels for GUID (mount)"
  ), je(e).filter(({ label: r }) => !t.has(r)).map(({ label: r, value: o }) => ({
    name: r,
    value: o,
    prevValue: void 0,
    hook: null,
    isIdenticalValueChange: !1
  }));
}
function cr(e, t) {
  let n = e, r = !0, o = 0;
  const i = 3;
  for (; r && o < i; ) {
    r = !1, o++;
    const l = n.filter((g) => g.name !== "unknown" && Ae(g.value)).map((g) => ({
      label: g.name,
      value: g.value,
      prevValue: g.prevValue
    }));
    if (l.length === 0)
      break;
    const a = /* @__PURE__ */ new Map();
    for (const g of l) {
      const { label: m, value: p, prevValue: $ } = g;
      for (const [T, b] of Object.entries(p))
        typeof b != "function" && (a.has(b) || a.set(b, `${m}.${T}`));
      if ($ && Ae($)) {
        const T = $;
        for (const [b, y] of Object.entries(T))
          typeof y != "function" && (a.has(y) || a.set(y, `${m}.${b}`));
      }
    }
    n = n.map((g) => {
      const m = g.name.endsWith(".internal");
      if (g.name !== "unknown" && !m)
        return g;
      const p = a.has(g.value), $ = g.prevValue !== void 0 ? a.has(g.prevValue) : !0;
      if (p && $) {
        const T = a.get(g.value);
        return r = !0, {
          ...g,
          name: T
        };
      }
      return g;
    });
  }
  const s = /* @__PURE__ */ new Map();
  function c(l, a, d = /* @__PURE__ */ new Set()) {
    if (!d.has(l)) {
      d.add(l);
      for (const g of Object.keys(l)) {
        const m = Object.getOwnPropertyDescriptor(l, g), p = `${a}.${g}`;
        if (m && typeof m.get == "function")
          try {
            const $ = l[g];
            $ != null && typeof $ != "function" && (s.set($, p), Ae($) && c(
              $,
              p,
              d
            ));
          } catch {
            continue;
          }
        else if (m && m.value != null) {
          const $ = l[g];
          Ae($) && typeof $ != "function" && c(
            $,
            p,
            d
          );
        }
      }
    }
  }
  for (const l of n) {
    if (l.name === "unknown" || !Ae(l.value))
      continue;
    const a = l.value;
    c(a, l.name);
  }
  const u = n.map((l) => {
    if (l.name !== "unknown")
      return l;
    if (s.has(l.value)) {
      const a = s.get(l.value);
      return {
        ...l,
        name: a
      };
    }
    return l;
  }), f = /* @__PURE__ */ new Map();
  for (const l of u)
    l.name !== "unknown" && Ae(l.value) && f.set(l.value, l.name);
  return u.map((l) => {
    if (l.name !== "unknown")
      return l;
    if (f.has(l.value)) {
      const a = f.get(l.value);
      return {
        ...l,
        name: `${a}.unknown`
      };
    }
    return l;
  }).map((l, a) => {
    if (l.name !== "unknown")
      return l;
    const d = u.map((T, b) => ({ entry: T, index: b })).filter(({ entry: T }) => T.name !== "unknown" && yn(T.value)), g = d.filter(({ index: T }) => T < a), m = d.filter(({ index: T }) => T > a);
    let p;
    if (g.length > 0 ? p = g[g.length - 1] : m.length > 0 && (p = m[0]), !p) {
      const b = (t ? je(t) : []).filter((y) => yn(y.value)).reverse()[0];
      b && (p = {
        entry: {
          name: b.label,
          value: b.value
        },
        index: -1
      });
    }
    const $ = l.value === null || l.value === void 0 || typeof l.value == "string" || typeof l.value == "number" || typeof l.value == "boolean" || typeof l.value == "bigint" || typeof l.value == "symbol";
    if (p && !$) {
      const T = p.entry.name;
      return {
        ...l,
        name: `${T}.internal`
      };
    }
    return l;
  });
}
function yn(e) {
  return typeof e != "object" || e === null ? !1 : Object.entries(e).some(([r, o]) => typeof o == "function");
}
function Ae(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === Object.prototype || t === null;
}
function Di(e, t, n) {
  return {
    name: Fi(t, n),
    value: e,
    prevValue: void 0,
    hook: t,
    isIdenticalValueChange: !1
  };
}
function ar(e, t) {
  h.debug(
    `buildStateChanges: Processing mount - filtering ${e.length} useState values`
  );
  const r = ji(e).map(({ value: u, hook: f }) => Di(u, f, t)), o = new Set(
    r.map((u) => u.name)
  ), i = t.trackingGUID ? Ii(t.trackingGUID, o) : [], s = [...r, ...i], c = cr(s, t.trackingGUID);
  return h.trace(
    `buildStateChanges: EXIT (mount) - ${r.length} fiber + ${i.length} unmatched = ${c.length} total`
  ), c;
}
function Vi(e) {
  return e.filter(({ name: t, value: n, prevValue: r }) => r !== void 0 && r !== n && !qe(t) && n !== Ge && r !== Ge);
}
const _i = Z(
  "resolveHookLabel",
  "buildStateChanges",
  Qn
);
function zi(e, t) {
  const { anchors: n, allAnchors: r, trackingGUID: o } = t;
  h.debug("buildStateChanges: Resolving hook label (update)");
  const i = sr(e, n), s = _i(
    i,
    e == null ? void 0 : e.memoizedState,
    { guid: o ?? "", allAnchors: r }
  );
  return h.debug(`buildStateChanges: Resolved to "${s}"`), s;
}
const Sn = Z("stringify", "areValuesIdentical", mt);
function lr(e, t) {
  const n = h.enter("areValuesIdentical", e, t);
  try {
    if (e === t)
      return !0;
    const r = Sn(e), o = Sn(t);
    return r === o;
  } catch {
    return !1;
  } finally {
    h.exit(n);
  }
}
function qt(e, t) {
  return !!x().detectIdenticalValueChanges && e !== t && lr(e, t);
}
function Pi(e, t) {
  h.debug("buildStateChanges: Getting current labels");
  const n = je(e), r = Gn(e);
  h.debug("buildStateChanges: Building prev value map");
  const o = /* @__PURE__ */ new Map();
  for (const s of r)
    o.set(s.label, s.value);
  return h.debug("buildStateChanges: Filtering and mapping changes"), n.filter(({ label: s }) => !t.has(s)).map(({ label: s, value: c, prevValue: u }) => {
    const f = u !== void 0 ? u : o.get(s);
    if (f === void 0 || f === c) return null;
    const l = qt(
      f,
      c
    );
    return {
      name: s,
      value: c,
      prevValue: f,
      hook: null,
      isIdenticalValueChange: l
    };
  }).filter((s) => s !== null);
}
function Wi(e, t, n, r) {
  h.debug(
    "buildStateChanges: Checking identical value (update)"
  );
  const o = qt(t, e);
  return {
    name: zi(n, r),
    value: e,
    prevValue: t,
    hook: n,
    isIdenticalValueChange: o
  };
}
function Lt(e, t) {
  h.debug(
    `buildStateChanges: Processing update - filtering ${e.length} useState values`
  );
  const r = Vi(e).map(({ value: u, prevValue: f, hook: l }) => Wi(
    u,
    f,
    l,
    t
  )), o = new Set(
    r.map((u) => u.name)
  );
  h.debug(
    "buildStateChanges: Getting unmatched labels for GUID (update)"
  );
  const i = t.trackingGUID ? Pi(t.trackingGUID, o) : [], s = [...r, ...i], c = cr(s, t.trackingGUID);
  return h.trace(
    `buildStateChanges: EXIT (update) - ${r.length} fiber + ${i.length} unmatched = ${c.length} total`
  ), c;
}
function ut(e, t) {
  return h.debug("buildStateChanges: Saving prev labels"), Ko(t), e;
}
function Gi(e, t, n, r, o) {
  const i = h.enter(
    `buildStateChanges: ENTER (mount=${e}, useStateValues=${t.length}, trackingGUID=${o})`
  ), s = {
    anchors: n,
    allAnchors: r,
    trackingGUID: o
  }, c = e ? ar(t, s) : o ? ut(
    Lt(t, s),
    o
  ) : Lt(t, s);
  return h.exit(i), c;
}
function Ui() {
  return {
    buildTrackedMount: (e, t, n, r) => ar(t, {
      anchors: n,
      allAnchors: r,
      trackingGUID: e
    }),
    buildTrackedUpdate: (e, t, n, r) => ut(
      Lt(t, {
        anchors: n,
        allAnchors: r,
        trackingGUID: e
      }),
      e
    )
  };
}
function Hi(e) {
  return je(e).map(({ label: n, value: r }) => ({
    name: n,
    value: r,
    prevValue: void 0,
    hook: null,
    // No fiber reference needed
    isIdenticalValueChange: !1
  }));
}
function Bi(e) {
  return new Map(e.map(({ label: t, value: n }) => [t, n]));
}
function qi(e, t, n) {
  if (!n.has(e))
    return null;
  const r = n.get(e);
  if (r === t)
    return null;
  const o = qt(r, t);
  return {
    name: e,
    value: t,
    prevValue: r,
    hook: null,
    // Labels-only doesn't reference fiber hooks
    isIdenticalValueChange: o
  };
}
function Ki(e) {
  const t = je(e), n = Gn(e), r = Bi(n);
  return t.map(({ label: o, value: i }) => qi(o, i, r)).filter((o) => o !== null);
}
function Ji() {
  return {
    buildTrackedMount: (e) => ut(
      Hi(e),
      e
    ),
    buildTrackedUpdate: (e) => ut(
      Ki(e),
      e
    )
  };
}
function Xi() {
  return (x().trackedStateResolution ?? "hybrid") === "labels-only" ? Ji() : Ui();
}
function Kt(e) {
  const t = /* @__PURE__ */ new Set(), n = x();
  if (e && n.skippedObjectProps)
    for (const r of n.skippedObjectProps)
      r.objectName === e && r.propNames.forEach((o) => {
        t.add(o);
      });
  return t;
}
function Yi(e, t) {
  var r;
  const n = [];
  try {
    const o = e.memoizedProps || e.pendingProps, i = (r = e.alternate) == null ? void 0 : r.memoizedProps;
    if (!o || !i) return n;
    const s = Kt(t);
    for (const [c, u] of Object.entries(o)) {
      const f = i[c];
      qe(c) || c === "children" || s.has(c) || f !== u && n.push({
        name: c,
        value: u,
        prevValue: f
      });
    }
  } catch {
  }
  return n;
}
function Zi(e, t, n) {
  if (e) {
    const s = t.memoizedProps || t.pendingProps, c = [];
    if (s && typeof s == "object") {
      const u = Kt(n || void 0);
      for (const [f, l] of Object.entries(s))
        qe(f) || f === "children" || u.has(f) || c.push({
          name: f,
          value: l,
          prevValue: void 0,
          isIdenticalValueChange: !1
        });
    }
    return c;
  }
  const r = Yi(
    t,
    n || void 0
  ), o = n === "Unknown";
  return r.map((s) => {
    const c = !o && !!x().detectIdenticalValueChanges && s.prevValue !== s.value && lr(s.prevValue, s.value);
    return { ...s, isIdenticalValueChange: c };
  });
}
function Qi(e, t) {
  return e.some((n) => n.isIdenticalValueChange === !0) || t.some((n) => n.isIdenticalValueChange === !0);
}
function es(e) {
  return e ? ze.consumeLogs(e) : [];
}
function ts(e, t) {
  const n = h.enter(`buildTreeNode: ENTER (depth=${t})`);
  if (!e || typeof e != "object")
    throw new Error("buildTreeNode requires a valid fiber object");
  h.debug("buildTreeNode: Extracting component name");
  const r = or(e.elementType) ?? "Unknown", o = wi(e);
  h.debug(`buildTreeNode: Component name is ${r}`);
  const i = !e.alternate;
  h.debug("buildTreeNode: Getting tracking GUID");
  const s = kt(e), c = !!s;
  let u = o;
  if (s) {
    const b = Hr(s);
    b && (u = b);
  }
  h.debug("buildTreeNode: Determining render type");
  const f = Ai(
    i,
    e.flags
  );
  h.debug("buildTreeNode: Extracting useState values");
  const l = Ei(e);
  h.debug("buildTreeNode: Getting hook anchors");
  const a = e.memoizedState, { anchors: d, allAnchors: g } = Li(a);
  h.debug("buildTreeNode: Building state changes");
  const m = s ? (() => {
    const b = Xi();
    return i ? b.buildTrackedMount(
      s,
      l,
      d,
      g
    ) : b.buildTrackedUpdate(
      s,
      l,
      d,
      g
    );
  })() : Gi(
    i,
    l,
    d,
    g,
    null
    // untracked
  );
  h.debug("buildTreeNode: Building prop changes");
  const p = Zi(i, e, u);
  h.debug("buildTreeNode: Computing identical value warning");
  const $ = Qi(
    m,
    p
  );
  h.debug("buildTreeNode: Consuming component logs");
  const T = es(s || null);
  return h.exit(n), {
    depth: t,
    componentName: r,
    displayName: u,
    renderType: f,
    flags: e.flags ?? 0,
    stateChanges: m,
    propChanges: p,
    componentLogs: T,
    isTracked: c,
    trackingGUID: s || null,
    hasIdenticalValueWarning: $
  };
}
function ns(e, t, n, r) {
  const o = h.enter(`traverseFiber: ENTER (depth=${t})`);
  if (!e || typeof e != "object")
    return h.debug("traverseFiber: EXIT (invalid fiber)"), h.exit(o), [];
  const i = [], s = [{ fiber: e, depth: t }], c = /* @__PURE__ */ new WeakSet();
  for (h.debug(
    `traverseFiber: Starting loop with ${s.length} items in stack`
  ); s.length > 0; ) {
    const u = s.pop();
    if (!u) continue;
    const { fiber: f, depth: l } = u;
    if (h.debug(
      `traverseFiber: Processing fiber at depth ${l}, stack size: ${s.length}`
    ), !f || typeof f != "object" || c.has(f) || (c.add(f), l > r))
      continue;
    const a = f;
    if (!a.elementType) {
      a.sibling && s.push({ fiber: a.sibling, depth: l }), a.child && s.push({ fiber: a.child, depth: l + 1 });
      continue;
    }
    if (!n(f)) {
      a.sibling && s.push({ fiber: a.sibling, depth: l });
      continue;
    }
    h.debug(
      `traverseFiber: Building node at depth ${l}`
    );
    try {
      const d = ts(f, l);
      i.push(d), h.debug(
        `traverseFiber: Successfully built node at depth ${l}`
      );
    } catch (d) {
      h.debug(
        `Error building node at depth ${l}:`,
        d
      );
    }
    h.debug(
      `traverseFiber: Pushing children of node at depth ${l}`
    ), a.sibling && s.push({ fiber: a.sibling, depth: l }), a.child && s.push({ fiber: a.child, depth: l + 1 });
  }
  return h.trace(`traverseFiber: EXIT (${i.length} nodes)`), h.exit(o), i;
}
function rs(e, t, n) {
  return (...r) => {
    const o = h.enter(t), i = e(...r), s = i && typeof i == "object" && Array.isArray(i) ? i.length : "result";
    return h.trace(`${t}: ${s} items`), h.exit(o), i;
  };
}
function os(e, t) {
  const n = x().maxFiberDepth ?? 500, r = x().includeNonTrackedBranches ?? !0, o = h.enter(`buildTreeFromFiber: (depth=${t})`), i = (u) => r ? !0 : !!kt(u) || Ci(u, kt), c = rs(ns, "buildTreeFromFiber")(e, t, i, n);
  return h.exit(o), c;
}
function ur(e, t) {
  if (e.isTracked || e.renderType === "Marker" || e.componentLogs.length > 0)
    return !1;
  const n = e.propChanges.length > 0, r = e.stateChanges.length > 0;
  let o;
  if (e.renderType === "Reconciled")
    o = t.includeReconciled;
  else if (e.renderType === "Skipped")
    o = t.includeSkipped;
  else if (e.renderType === "Mount")
    o = t.includeMount;
  else if (e.renderType === "Rendering")
    o = t.includeRendered ?? "never";
  else
    return !1;
  switch (o) {
    case "never":
      return !0;
    case "forProps":
      return !n;
    case "forState":
      return !r;
    case "forPropsOrState":
      return !n && !r;
    case "always":
      return !1;
    default:
      return !1;
  }
}
function jt(e, t, n) {
  const r = `... (${t} levels collapsed)`;
  return {
    depth: e,
    componentName: r,
    displayName: r,
    renderType: "Marker",
    flags: 0,
    stateChanges: Object.freeze([]),
    propChanges: Object.freeze([]),
    componentLogs: Object.freeze([]),
    isTracked: !1,
    trackingGUID: null,
    hasIdenticalValueWarning: !1,
    filteredNodeCount: n
  };
}
function is(e, t) {
  var i;
  if (e.length === 0)
    return [];
  const n = ((i = e[0]) == null ? void 0 : i.depth) ?? 0;
  let r = 0;
  for (; r < e.length; ) {
    const s = e[r];
    if (s && !ur(s, t))
      break;
    r++;
  }
  return r === 0 ? [...e] : r === e.length ? [jt(n, e.length, e.length)] : [jt(
    n,
    r,
    r
  ), ...e.slice(r)];
}
function ss(e, t) {
  if (e.length === 0)
    return [];
  const n = (i) => {
    if (i.currentEmptySequence === null)
      return i;
    const s = jt(
      i.currentEmptySequence.startDepth,
      i.currentEmptySequence.count,
      i.currentEmptySequence.count
    );
    return {
      result: [...i.result, s],
      currentEmptySequence: null
    };
  }, r = e.reduce(
    (i, s) => ur(s, t) ? i.currentEmptySequence === null ? {
      ...i,
      currentEmptySequence: {
        startDepth: s.depth,
        count: 1
      }
    } : {
      ...i,
      currentEmptySequence: {
        ...i.currentEmptySequence,
        count: i.currentEmptySequence.count + 1
      }
    } : {
      result: [...n(i).result, s],
      currentEmptySequence: null
    },
    { result: [], currentEmptySequence: null }
  );
  return n(r).result;
}
const cs = (e) => e, as = {
  none: cs,
  first: is,
  all: ss
};
function ls(e) {
  return as[e];
}
function us(e) {
  var o, i;
  const t = [];
  let n = 0;
  const r = /* @__PURE__ */ new Map();
  if (e.length > 0 && ((o = e[0]) == null ? void 0 : o.depth) === 20) {
    h.info("calculateVisualDepths - First 10 nodes:");
    for (let s = 0; s < Math.min(10, e.length); s++) {
      const c = e[s], u = (c == null ? void 0 : c.renderType) === "Marker" ? "M" : "C", f = (c == null ? void 0 : c.renderType) !== "Marker" ? (c == null ? void 0 : c.displayName) ?? "" : "";
      h.info(`  [${s}] ${u}(${c == null ? void 0 : c.depth}) ${f}`);
    }
  }
  for (let s = 0; s < e.length; s++) {
    const c = e[s], u = s > 0 ? e[s - 1] : null;
    if (s === 0 || c === void 0)
      t.push(0), n = 0, r.set((c == null ? void 0 : c.depth) ?? 0, 0);
    else if (u != null) {
      const f = c.renderType === "Marker", l = u.renderType === "Marker", a = u.depth, d = c.depth;
      if (f)
        if (d < a) {
          const g = r.get(d);
          if (g !== void 0)
            n = g;
          else {
            const m = a - d;
            n = Math.max(
              0,
              n - m
            );
          }
          t.push(n), r.set(d, n);
        } else
          t.push(n), d <= a && r.set(d, n);
      else if (l)
        d < a ? (n = 0, t.push(n), r.set(d, n)) : (n = (t[s - 1] ?? 0) + 1, t.push(n), r.set(d, n));
      else if (d > a)
        n++, t.push(n), r.set(d, n);
      else if (d === a)
        t.push(n), r.set(d, n);
      else {
        const g = r.get(d);
        if (g !== void 0)
          n = g;
        else {
          const m = a - d;
          n = Math.max(
            0,
            n - m
          );
        }
        t.push(n), r.set(d, n);
      }
    }
  }
  if (e.length > 0 && ((i = e[0]) == null ? void 0 : i.depth) === 20) {
    h.info(
      "calculateVisualDepths - Calculated depths for first 10 nodes:"
    );
    for (let s = 0; s < Math.min(10, e.length); s++) {
      const c = e[s], u = (c == null ? void 0 : c.renderType) === "Marker" ? "M" : "C", f = (c == null ? void 0 : c.renderType) !== "Marker" ? (c == null ? void 0 : c.displayName) ?? "" : "";
      h.info(
        `  [${s}] ${u}(${c == null ? void 0 : c.depth}) ${f} → visual depth ${t[s]}`
      );
    }
  }
  return t;
}
function Tn(e, t, n) {
  const r = "  ".repeat(Math.max(e - 1, 0)), o = n ? ` (Level: ${t})` : "";
  return `${r}└─┐${o}`;
}
const fs = Z(
  "normalizeValueDeepWithIDs",
  "stringifyForDisplay",
  it
);
function Oe(e) {
  try {
    if (typeof e == "function")
      return `(fn:${We(e)})`;
    if (typeof e != "object" || e === null)
      return String(e);
    const t = fs(e);
    return Gt.configure({
      maximumDepth: 10,
      maximumBreadth: 50,
      circularValue: "[Circular]"
    })(t) ?? "[Unserializable]";
  } catch (t) {
    try {
      return `[Error serializing: ${t instanceof Error ? t.message : String(t)}]`;
    } catch {
      return "[Unserializable]";
    }
  }
}
function ds(e) {
  return "constructor" in e && e.constructor !== null && typeof e.constructor == "function" && "name" in e.constructor && typeof e.constructor.name == "string";
}
function gs(e, t, n, r, o, i) {
  const s = [{ value: e, depth: t }];
  for (; s.length > 0; ) {
    const c = s.pop();
    if (!c) continue;
    const { value: u, depth: f } = c;
    if (f > i || n.count > o)
      return !1;
    if (n.count++, typeof u != "object" || u === null || r.has(u))
      continue;
    r.add(u);
    const l = Object.getPrototypeOf(u);
    if (l !== Object.prototype && l !== Array.prototype && l !== null) {
      const a = ds(u) ? u.constructor.name : "Object";
      if (typeof Element < "u" && u instanceof Element || typeof HTMLElement < "u" && u instanceof HTMLElement || typeof Node < "u" && u instanceof Node || a.includes("HTML") || a.includes("Element") || a === "Window" || a === "Document")
        continue;
    }
    try {
      const a = Object.keys(u);
      for (let d = a.length - 1; d >= 0; d--) {
        const g = a[d];
        if (g === void 0) continue;
        const m = u[g];
        s.push({ value: m, depth: f + 1 });
      }
    } catch {
      return !1;
    }
  }
  return !0;
}
function he(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = 1e6;
  return gs(
    e,
    0,
    { count: 0 },
    /* @__PURE__ */ new WeakSet(),
    t,
    30
  ) ? null : `[Too large object to render. >${t} nodes]`;
}
function hs(e) {
  const t = he(e);
  return t !== null ? t : Oe(e);
}
function $n(e, t) {
  const n = he(e), r = he(t), o = n ?? Oe(e), i = r ?? Oe(t), s = o.length + i.length;
  if (s < 20)
    return `${o} → ${i}`;
  if (s <= 200)
    return `
${o}
→
${i}`;
  {
    const c = o.length > 200 ? `${o.slice(0, 200)}... (${o.length} characters)` : o, u = i.length > 200 ? `${i.slice(0, 200)}... (${i.length} characters)` : i;
    return `
${c}
→
${u}`;
  }
}
function ps(e) {
  const t = he(e);
  return t !== null ? t : Oe(e);
}
function Mn(e, t) {
  const n = he(e), r = he(t), o = n ?? Oe(e), i = r ?? Oe(t), s = o.length + i.length;
  if (s < 20)
    return `${o} → ${i}`;
  if (s <= 200)
    return `
${o}
→
${i}`;
  {
    const c = o.length > 200 ? `${o.slice(0, 200)}... (${o.length} characters)` : o, u = i.length > 200 ? `${i.slice(0, 200)}... (${i.length} characters)` : i;
    return `
${c}
→
${u}`;
  }
}
function Jt(e, t = 1e3, n = 20) {
  if (typeof e == "function")
    return `(fn:${We(e)})`;
  if (typeof e != "object" || e === null)
    return e;
  const r = Array.isArray(e) ? [] : {}, o = [{ source: e, target: r, depth: 0 }];
  let i = 0;
  for (; o.length > 0; ) {
    const s = o.pop();
    if (!s) continue;
    const { source: c, target: u, depth: f, ancestors: l } = s;
    if (f > n) {
      Array.isArray(u) || (u["[Max Depth]"] = !0);
      continue;
    }
    if (i > t)
      continue;
    i++;
    const a = Object.keys(c);
    for (let d = a.length - 1; d >= 0; d--) {
      const g = a[d];
      if (g === void 0) continue;
      const m = c[g];
      if (i >= t) {
        u["[Max Nodes]"] = !0;
        break;
      }
      if (typeof m == "function") {
        i++, u[g] = `(fn:${We(m)})`;
        continue;
      }
      if (typeof m != "object" || m === null) {
        i++, u[g] = m;
        continue;
      }
      if (f + 1 > n) {
        u[g] = "[Max Depth]";
        continue;
      }
      const p = l || /* @__PURE__ */ new Set();
      if (p.add(c), p.has(m)) {
        u[g] = "[Circular]";
        continue;
      }
      const $ = Array.isArray(m) ? [] : {};
      u[g] = $, o.push({
        source: m,
        target: $,
        depth: f + 1,
        ancestors: new Set(p)
      });
    }
  }
  return r;
}
function ft(e) {
  if (e == null)
    return !0;
  const t = typeof e;
  return t === "boolean" || t === "number" || t === "bigint" || t === "function" ? !0 : t === "string" ? e.length <= 50 : !1;
}
function vt(e, t) {
  if (!t) {
    const n = he(e);
    if (n)
      return n;
  }
  return Jt(e);
}
function ms(e, t, n) {
  const r = t.valueRenderingMode === "as-is", o = e.isIdenticalValueChange === !0 && t.detectIdenticalValueChanges;
  if (n)
    if (r) {
      const i = vt(e.value, r);
      return {
        level: "state-initial",
        message: `Initial state ${e.name}: `,
        values: [i]
      };
    } else {
      const i = ps(e.value);
      return {
        level: "state-initial",
        message: `Initial state ${e.name}: ${i}`
      };
    }
  else if (r) {
    const i = vt(e.prevValue, r), s = vt(e.value, r);
    if (ft(e.prevValue) && ft(e.value)) {
      const u = Mn(e.prevValue, e.value), f = `Changed state ${e.name}`;
      return o ? {
        level: "state-identical",
        message: `${f} (identical value):`,
        values: [u]
      } : {
        level: "state",
        message: `${f}:`,
        values: [u]
      };
    } else {
      const u = `Changed state ${e.name}:`;
      return {
        level: o ? "state-identical" : "state",
        message: o ? `${u} (identical value)` : u,
        values: [i, s]
      };
    }
  } else {
    const i = Mn(e.prevValue, e.value), s = `State change ${e.name}`;
    return o ? {
      level: "state-identical",
      message: `${s} (identical value): ${i}`
    } : {
      level: "state",
      message: `${s}: ${i}`
    };
  }
}
function Ot(e, t) {
  if (!t) {
    const n = he(e);
    if (n)
      return n;
  }
  return Jt(e);
}
function bs(e, t, n) {
  const r = t.valueRenderingMode === "as-is", o = e.isIdenticalValueChange === !0 && t.detectIdenticalValueChanges, i = Kt(t.displayName), s = qe(e.name) || i.has(e.name);
  if (n)
    if (r) {
      const c = Ot(e.value, r);
      return {
        level: "prop-initial",
        message: `Initial prop ${e.name}: `,
        values: [c],
        shouldSkip: s
      };
    } else {
      const c = hs(e.value);
      return {
        level: "prop-initial",
        message: `Initial prop ${e.name}: ${c}`,
        shouldSkip: s
      };
    }
  else if (r) {
    const c = Ot(e.prevValue, r), u = Ot(e.value, r);
    if (ft(e.prevValue) && ft(e.value)) {
      const l = $n(e.prevValue, e.value), a = `Changed prop ${e.name}`;
      return o ? {
        level: "prop-identical",
        message: `${a} (identical value):`,
        shouldSkip: s,
        values: [l]
      } : {
        level: "prop",
        message: `${a}:`,
        shouldSkip: s,
        values: [l]
      };
    } else {
      const l = `Changed prop ${e.name}:`;
      return {
        level: o ? "prop-identical" : "prop",
        message: o ? `${l} (identical value)` : l,
        values: [c, u],
        shouldSkip: s
      };
    }
  } else {
    const c = $n(e.prevValue, e.value), u = `Prop change ${e.name}`;
    return o ? {
      level: "prop-identical",
      message: `${u} (identical value): ${c}`,
      shouldSkip: s
    } : {
      level: "prop",
      message: `${u}: ${c}`,
      shouldSkip: s
    };
  }
}
function ys(e, t) {
  if (!t) {
    const n = he(e);
    if (n)
      return n;
  }
  return Jt(e);
}
function Ss(e, t) {
  const n = t.valueRenderingMode === "as-is", { message: r, level: o, args: i } = e;
  if (n) {
    const s = i.map((c) => ys(c, n));
    return {
      level: o,
      message: r,
      args: s
    };
  } else {
    const s = i.length > 0 ? ` ${JSON.stringify(i)}` : "";
    return {
      level: o,
      message: `${r}${s}`
    };
  }
}
function Ts(e, t) {
  try {
    return JSON.stringify(e) === JSON.stringify(t);
  } catch {
    return !1;
  }
}
function fr(e, t, n, r) {
  return t === n ? r ? { name: e, status: "unchanged", prevValue: t, currentValue: n } : null : Ts(t, n) ? { name: e, status: "reference", prevValue: t, currentValue: n } : { name: e, status: "changed", prevValue: t, currentValue: n };
}
function $s(e, t, n, r) {
  return e in t ? e in n ? fr(e, t[e], n[e], r) : { name: e, status: "removed", prevValue: t[e] } : { name: e, status: "added", currentValue: n[e] };
}
function Ms(e) {
  return e.length > 0 && !e.every((t) => t.status === "unchanged");
}
function Cn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function Cs(e, t, n) {
  const { maxFields: r = 20, showUnchanged: o = !1 } = n, i = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]);
  if (i.size < 3 || i.size > 50) return null;
  const s = [...i].slice(0, r).map((c) => $s(c, e, t, o)).filter((c) => c !== null);
  return Ms(s) ? s : null;
}
function Es(e, t, n) {
  const r = `[${e}]`;
  return e >= t.length ? { name: r, status: "added", currentValue: n[e] } : e >= n.length ? { name: r, status: "removed", prevValue: t[e] } : fr(r, t[e], n[e], !1);
}
function ws(e, t, n) {
  const r = Math.max(e.length, t.length);
  if (r < 1 || r > 50) return null;
  const i = Array.from({ length: Math.min(r, n) }, (s, c) => c).map((s) => Es(s, e, t)).filter((s) => s !== null);
  return i.length > 0 ? i : null;
}
function dr(e, t, n = {}) {
  return Array.isArray(e) && Array.isArray(t) ? ws(e, t, n.maxFields ?? 20) : !Cn(e) || !Cn(t) ? null : Cs(e, t, n);
}
function Qe(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = Oe(e);
  return t.length > 80 ? `${t.slice(0, 77)}...` : t;
}
const vs = {
  changed: (e) => `~ ${e.name}: ${Qe(e.prevValue)} → ${Qe(e.currentValue)}`,
  added: (e) => `+ ${e.name}: ${Qe(e.currentValue)}`,
  removed: (e) => `- ${e.name}: ${Qe(e.prevValue)}`,
  unchanged: (e) => `  ${e.name}: (unchanged)`,
  reference: (e) => `≈ ${e.name}: (same content, new reference)`
};
function Os(e) {
  return vs[e.status](e);
}
function Rs(e) {
  const t = [], n = e.filter((s) => s.status === "changed").length, r = e.filter((s) => s.status === "added").length, o = e.filter((s) => s.status === "removed").length, i = e.filter((s) => s.status === "reference").length;
  return n > 0 && t.push(`${n} changed`), r > 0 && t.push(`${r} added`), o > 0 && t.push(`${o} removed`), i > 0 && t.push(`${i} reference-only`), t;
}
function xs(e, t) {
  const n = Rs(e);
  return n.length === 0 ? [] : [`${t}  Fields: ${n.join(", ")}:`];
}
function ks(e, t) {
  return e.filter((n) => n.status !== "reference" && n.status !== "unchanged").map((n) => `${t}    ${Os(n)}`);
}
function As(e, t) {
  const n = e.filter((o) => o.status === "reference");
  if (n.length === 0) return [];
  const r = n.map((o) => o.name).join(", ");
  return [`${t}    ≈ ${r} (same content, new reference)`];
}
function gr(e, t) {
  return !e || e.length === 0 ? [] : [
    ...xs(e, t),
    ...ks(e, t),
    ...As(e, t)
  ];
}
function Ns(e, t, n) {
  let r;
  if (e.level === "state-identical" ? r = {
    logFn: Ti,
    args: [t, e.message]
  } : e.level === "state-initial" ? r = {
    logFn: bn,
    args: [t, e.message, !0]
  } : r = {
    logFn: bn,
    args: [t, e.message, !1]
  }, n && e.values) {
    const o = e.values;
    return {
      logFn: () => {
        if (o.length === 1)
          r.logFn(...r.args, o[0]);
        else if (r.logFn(...r.args), J(`${t}  Before`, o[0]), J(`${t}  After `, o[1]), e.level !== "state-identical") {
          const i = dr(o[0], o[1]);
          if (i) {
            const s = gr(i, t);
            for (const c of s)
              J(c);
          }
        }
      },
      args: []
    };
  }
  return r;
}
function Ls(e, t, n) {
  if (e.shouldSkip)
    return null;
  let r;
  if (e.level === "prop-identical" ? r = {
    logFn: $i,
    args: [t, e.message]
  } : e.level === "prop-initial" ? r = {
    logFn: mn,
    args: [t, e.message, !0]
  } : r = {
    logFn: mn,
    args: [t, e.message, !1]
  }, n && e.values) {
    const o = e.values;
    return {
      logFn: () => {
        if (o.length === 1)
          r.logFn(...r.args, o[0]);
        else if (r.logFn(...r.args), J(`${t}  Before`, o[0]), J(`${t}  After `, o[1]), e.level !== "prop-identical") {
          const i = dr(o[0], o[1]);
          if (i) {
            const s = gr(i, t);
            for (const c of s)
              J(c);
          }
        }
      },
      args: []
    };
  }
  return r;
}
function js(e, t) {
  const n = [t, e.message];
  e.args && n.push(...e.args);
  let r;
  return e.level === "error" ? r = bi : e.level === "warn" ? r = mi : r = pi, { logFn: r, args: n };
}
function hr(e, t = "") {
  const { displayName: n, renderType: r } = e, o = {
    valueRenderingMode: x().valueRenderingMode ?? "serialized",
    detectIdenticalValueChanges: x().detectIdenticalValueChanges || !1,
    displayName: n
  }, i = r === "Mount", s = o.valueRenderingMode === "as-is";
  e.propChanges.forEach((c) => {
    const u = bs(c, o, i), f = Ls(u, t, s);
    f && f.logFn(...f.args);
  }), e.stateChanges.forEach((c) => {
    const u = ms(c, o, i), f = Ns(u, t, s);
    f.logFn(...f.args);
  }), e.componentLogs.forEach((c) => {
    const u = Ss(c, o), f = js(u, t);
    f.logFn(...f.args);
  });
}
const pr = (e, t, n) => {
  const r = e instanceof RegExp ? En(e, n) : e, o = t instanceof RegExp ? En(t, n) : t, i = r !== null && o != null && Fs(r, o, n);
  return i && {
    start: i[0],
    end: i[1],
    pre: n.slice(0, i[0]),
    body: n.slice(i[0] + r.length, i[1]),
    post: n.slice(i[1] + o.length)
  };
}, En = (e, t) => {
  const n = t.match(e);
  return n ? n[0] : null;
}, Fs = (e, t, n) => {
  let r, o, i, s, c, u = n.indexOf(e), f = n.indexOf(t, u + 1), l = u;
  if (u >= 0 && f > 0) {
    if (e === t)
      return [u, f];
    for (r = [], i = n.length; l >= 0 && !c; ) {
      if (l === u)
        r.push(l), u = n.indexOf(e, l + 1);
      else if (r.length === 1) {
        const a = r.pop();
        a !== void 0 && (c = [a, f]);
      } else
        o = r.pop(), o !== void 0 && o < i && (i = o, s = f), f = n.indexOf(t, l + 1);
      l = u < f && u >= 0 ? u : f;
    }
    r.length && s !== void 0 && (c = [i, s]);
  }
  return c;
}, mr = "\0SLASH" + Math.random() + "\0", br = "\0OPEN" + Math.random() + "\0", Xt = "\0CLOSE" + Math.random() + "\0", yr = "\0COMMA" + Math.random() + "\0", Sr = "\0PERIOD" + Math.random() + "\0", Is = new RegExp(mr, "g"), Ds = new RegExp(br, "g"), Vs = new RegExp(Xt, "g"), _s = new RegExp(yr, "g"), zs = new RegExp(Sr, "g"), Ps = /\\\\/g, Ws = /\\{/g, Gs = /\\}/g, Us = /\\,/g, Hs = /\\./g;
function Rt(e) {
  return isNaN(e) ? e.charCodeAt(0) : parseInt(e, 10);
}
function Bs(e) {
  return e.replace(Ps, mr).replace(Ws, br).replace(Gs, Xt).replace(Us, yr).replace(Hs, Sr);
}
function qs(e) {
  return e.replace(Is, "\\").replace(Ds, "{").replace(Vs, "}").replace(_s, ",").replace(zs, ".");
}
function Tr(e) {
  if (!e)
    return [""];
  const t = [], n = pr("{", "}", e);
  if (!n)
    return e.split(",");
  const { pre: r, body: o, post: i } = n, s = r.split(",");
  s[s.length - 1] += "{" + o + "}";
  const c = Tr(i);
  return i.length && (s[s.length - 1] += c.shift(), s.push.apply(s, c)), t.push.apply(t, s), t;
}
function Ks(e) {
  return e ? (e.slice(0, 2) === "{}" && (e = "\\{\\}" + e.slice(2)), De(Bs(e), !0).map(qs)) : [];
}
function Js(e) {
  return "{" + e + "}";
}
function Xs(e) {
  return /^-?0\d/.test(e);
}
function Ys(e, t) {
  return e <= t;
}
function Zs(e, t) {
  return e >= t;
}
function De(e, t) {
  const n = [], r = pr("{", "}", e);
  if (!r)
    return [e];
  const o = r.pre, i = r.post.length ? De(r.post, !1) : [""];
  if (/\$$/.test(r.pre))
    for (let s = 0; s < i.length; s++) {
      const c = o + "{" + r.body + "}" + i[s];
      n.push(c);
    }
  else {
    const s = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(r.body), c = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(r.body), u = s || c, f = r.body.indexOf(",") >= 0;
    if (!u && !f)
      return r.post.match(/,(?!,).*\}/) ? (e = r.pre + "{" + r.body + Xt + r.post, De(e)) : [e];
    let l;
    if (u)
      l = r.body.split(/\.\./);
    else if (l = Tr(r.body), l.length === 1 && l[0] !== void 0 && (l = De(l[0], !1).map(Js), l.length === 1))
      return i.map((d) => r.pre + l[0] + d);
    let a;
    if (u && l[0] !== void 0 && l[1] !== void 0) {
      const d = Rt(l[0]), g = Rt(l[1]), m = Math.max(l[0].length, l[1].length);
      let p = l.length === 3 && l[2] !== void 0 ? Math.abs(Rt(l[2])) : 1, $ = Ys;
      g < d && (p *= -1, $ = Zs);
      const b = l.some(Xs);
      a = [];
      for (let y = d; $(y, g); y += p) {
        let C;
        if (c)
          C = String.fromCharCode(y), C === "\\" && (C = "");
        else if (C = String(y), b) {
          const L = m - C.length;
          if (L > 0) {
            const N = new Array(L + 1).join("0");
            y < 0 ? C = "-" + N + C.slice(1) : C = N + C;
          }
        }
        a.push(C);
      }
    } else {
      a = [];
      for (let d = 0; d < l.length; d++)
        a.push.apply(a, De(l[d], !1));
    }
    for (let d = 0; d < a.length; d++)
      for (let g = 0; g < i.length; g++) {
        const m = o + a[d] + i[g];
        (!t || u || m) && n.push(m);
      }
  }
  return n;
}
const Qs = 1024 * 64, dt = (e) => {
  if (typeof e != "string")
    throw new TypeError("invalid pattern");
  if (e.length > Qs)
    throw new TypeError("pattern is too long");
}, ec = {
  "[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", !0],
  "[:alpha:]": ["\\p{L}\\p{Nl}", !0],
  "[:ascii:]": ["\\x00-\\x7f", !1],
  "[:blank:]": ["\\p{Zs}\\t", !0],
  "[:cntrl:]": ["\\p{Cc}", !0],
  "[:digit:]": ["\\p{Nd}", !0],
  "[:graph:]": ["\\p{Z}\\p{C}", !0, !0],
  "[:lower:]": ["\\p{Ll}", !0],
  "[:print:]": ["\\p{C}", !0],
  "[:punct:]": ["\\p{P}", !0],
  "[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", !0],
  "[:upper:]": ["\\p{Lu}", !0],
  "[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", !0],
  "[:xdigit:]": ["A-Fa-f0-9", !1]
}, Fe = (e) => e.replace(/[[\]\\-]/g, "\\$&"), tc = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), wn = (e) => e.join(""), nc = (e, t) => {
  const n = t;
  if (e.charAt(n) !== "[")
    throw new Error("not in a brace expression");
  const r = [], o = [];
  let i = n + 1, s = !1, c = !1, u = !1, f = !1, l = n, a = "";
  e: for (; i < e.length; ) {
    const p = e.charAt(i);
    if ((p === "!" || p === "^") && i === n + 1) {
      f = !0, i++;
      continue;
    }
    if (p === "]" && s && !u) {
      l = i + 1;
      break;
    }
    if (s = !0, p === "\\" && !u) {
      u = !0, i++;
      continue;
    }
    if (p === "[" && !u) {
      for (const [$, [T, b, y]] of Object.entries(ec))
        if (e.startsWith($, i)) {
          if (a)
            return ["$.", !1, e.length - n, !0];
          i += $.length, y ? o.push(T) : r.push(T), c = c || b;
          continue e;
        }
    }
    if (u = !1, a) {
      p > a ? r.push(Fe(a) + "-" + Fe(p)) : p === a && r.push(Fe(p)), a = "", i++;
      continue;
    }
    if (e.startsWith("-]", i + 1)) {
      r.push(Fe(p + "-")), i += 2;
      continue;
    }
    if (e.startsWith("-", i + 1)) {
      a = p, i += 2;
      continue;
    }
    r.push(Fe(p)), i++;
  }
  if (l < i)
    return ["", !1, 0, !1];
  if (!r.length && !o.length)
    return ["$.", !1, e.length - n, !0];
  if (o.length === 0 && r.length === 1 && /^\\?.$/.test(r[0]) && !f) {
    const p = r[0].length === 2 ? r[0].slice(-1) : r[0];
    return [tc(p), !1, l - n, !1];
  }
  const d = "[" + (f ? "^" : "") + wn(r) + "]", g = "[" + (f ? "" : "^") + wn(o) + "]";
  return [r.length && o.length ? "(" + d + "|" + g + ")" : r.length ? d : g, c, l - n, !0];
}, Ve = (e, { windowsPathsNoEscape: t = !1, magicalBraces: n = !0 } = {}) => n ? t ? e.replace(/\[([^\/\\])\]/g, "$1") : e.replace(/((?!\\).|^)\[([^\/\\])\]/g, "$1$2").replace(/\\([^\/])/g, "$1") : t ? e.replace(/\[([^\/\\{}])\]/g, "$1") : e.replace(/((?!\\).|^)\[([^\/\\{}])\]/g, "$1$2").replace(/\\([^\/{}])/g, "$1"), rc = /* @__PURE__ */ new Set(["!", "?", "+", "*", "@"]), vn = (e) => rc.has(e), oc = "(?!(?:^|/)\\.\\.?(?:$|/))", et = "(?!\\.)", ic = /* @__PURE__ */ new Set(["[", "."]), sc = /* @__PURE__ */ new Set(["..", "."]), cc = new Set("().*{}+?[]^$\\!"), ac = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), Yt = "[^/]", On = Yt + "*?", Rn = Yt + "+?";
var G, H, ge, I, P, me, Ee, be, ce, we, He, Re, $r, Se, ot, Ft, Mr;
const K = class K {
  constructor(t, n, r = {}) {
    Y(this, Re);
    z(this, "type");
    Y(this, G);
    Y(this, H);
    Y(this, ge, !1);
    Y(this, I, []);
    Y(this, P);
    Y(this, me);
    Y(this, Ee);
    Y(this, be, !1);
    Y(this, ce);
    Y(this, we);
    // set to true if it's an extglob with no children
    // (which really means one child of '')
    Y(this, He, !1);
    this.type = t, t && D(this, H, !0), D(this, P, n), D(this, G, M(this, P) ? M(M(this, P), G) : this), D(this, ce, M(this, G) === this ? r : M(M(this, G), ce)), D(this, Ee, M(this, G) === this ? [] : M(M(this, G), Ee)), t === "!" && !M(M(this, G), be) && M(this, Ee).push(this), D(this, me, M(this, P) ? M(M(this, P), I).length : 0);
  }
  get hasMagic() {
    if (M(this, H) !== void 0)
      return M(this, H);
    for (const t of M(this, I))
      if (typeof t != "string" && (t.type || t.hasMagic))
        return D(this, H, !0);
    return M(this, H);
  }
  // reconstructs the pattern
  toString() {
    return M(this, we) !== void 0 ? M(this, we) : this.type ? D(this, we, this.type + "(" + M(this, I).map((t) => String(t)).join("|") + ")") : D(this, we, M(this, I).map((t) => String(t)).join(""));
  }
  push(...t) {
    for (const n of t)
      if (n !== "") {
        if (typeof n != "string" && !(n instanceof K && M(n, P) === this))
          throw new Error("invalid part: " + n);
        M(this, I).push(n);
      }
  }
  toJSON() {
    var n;
    const t = this.type === null ? M(this, I).slice().map((r) => typeof r == "string" ? r : r.toJSON()) : [this.type, ...M(this, I).map((r) => r.toJSON())];
    return this.isStart() && !this.type && t.unshift([]), this.isEnd() && (this === M(this, G) || M(M(this, G), be) && ((n = M(this, P)) == null ? void 0 : n.type) === "!") && t.push({}), t;
  }
  isStart() {
    var n;
    if (M(this, G) === this)
      return !0;
    if (!((n = M(this, P)) != null && n.isStart()))
      return !1;
    if (M(this, me) === 0)
      return !0;
    const t = M(this, P);
    for (let r = 0; r < M(this, me); r++) {
      const o = M(t, I)[r];
      if (!(o instanceof K && o.type === "!"))
        return !1;
    }
    return !0;
  }
  isEnd() {
    var n, r, o;
    if (M(this, G) === this || ((n = M(this, P)) == null ? void 0 : n.type) === "!")
      return !0;
    if (!((r = M(this, P)) != null && r.isEnd()))
      return !1;
    if (!this.type)
      return (o = M(this, P)) == null ? void 0 : o.isEnd();
    const t = M(this, P) ? M(M(this, P), I).length : 0;
    return M(this, me) === t - 1;
  }
  copyIn(t) {
    typeof t == "string" ? this.push(t) : this.push(t.clone(this));
  }
  clone(t) {
    const n = new K(this.type, t);
    for (const r of M(this, I))
      n.copyIn(r);
    return n;
  }
  static fromGlob(t, n = {}) {
    var o;
    const r = new K(null, void 0, n);
    return pe(o = K, Se, ot).call(o, t, r, 0, n), r;
  }
  // returns the regular expression if there's magic, or the unescaped
  // string if not.
  toMMPattern() {
    if (this !== M(this, G))
      return M(this, G).toMMPattern();
    const t = this.toString(), [n, r, o, i] = this.toRegExpSource();
    if (!(o || M(this, H) || M(this, ce).nocase && !M(this, ce).nocaseMagicOnly && t.toUpperCase() !== t.toLowerCase()))
      return r;
    const c = (M(this, ce).nocase ? "i" : "") + (i ? "u" : "");
    return Object.assign(new RegExp(`^${n}$`, c), {
      _src: n,
      _glob: t
    });
  }
  get options() {
    return M(this, ce);
  }
  // returns the string match, the regexp source, whether there's magic
  // in the regexp (so a regular expression is required) and whether or
  // not the uflag is needed for the regular expression (for posix classes)
  // TODO: instead of injecting the start/end at this point, just return
  // the BODY of the regexp, along with the start/end portions suitable
  // for binding the start/end in either a joined full-path makeRe context
  // (where we bind to (^|/), or a standalone matchPart context (where
  // we bind to ^, and not /).  Otherwise slashes get duped!
  //
  // In part-matching mode, the start is:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: ^(?!\.\.?$)
  // - if dots allowed or not possible: ^
  // - if dots possible and not allowed: ^(?!\.)
  // end is:
  // - if not isEnd(): nothing
  // - else: $
  //
  // In full-path matching mode, we put the slash at the START of the
  // pattern, so start is:
  // - if first pattern: same as part-matching mode
  // - if not isStart(): nothing
  // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
  // - if dots allowed or not possible: /
  // - if dots possible and not allowed: /(?!\.)
  // end is:
  // - if last pattern, same as part-matching mode
  // - else nothing
  //
  // Always put the (?:$|/) on negated tails, though, because that has to be
  // there to bind the end of the negated pattern portion, and it's easier to
  // just stick it in now rather than try to inject it later in the middle of
  // the pattern.
  //
  // We can just always return the same end, and leave it up to the caller
  // to know whether it's going to be used joined or in parts.
  // And, if the start is adjusted slightly, can do the same there:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
  // - if dots allowed or not possible: (?:/|^)
  // - if dots possible and not allowed: (?:/|^)(?!\.)
  //
  // But it's better to have a simpler binding without a conditional, for
  // performance, so probably better to return both start options.
  //
  // Then the caller just ignores the end if it's not the first pattern,
  // and the start always gets applied.
  //
  // But that's always going to be $ if it's the ending pattern, or nothing,
  // so the caller can just attach $ at the end of the pattern when building.
  //
  // So the todo is:
  // - better detect what kind of start is needed
  // - return both flavors of starting pattern
  // - attach $ at the end of the pattern when creating the actual RegExp
  //
  // Ah, but wait, no, that all only applies to the root when the first pattern
  // is not an extglob. If the first pattern IS an extglob, then we need all
  // that dot prevention biz to live in the extglob portions, because eg
  // +(*|.x*) can match .xy but not .yx.
  //
  // So, return the two flavors if it's #root and the first child is not an
  // AST, otherwise leave it to the child AST to handle it, and there,
  // use the (?:^|/) style of start binding.
  //
  // Even simplified further:
  // - Since the start for a join is eg /(?!\.) and the start for a part
  // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
  // or start or whatever) and prepend ^ or / at the Regexp construction.
  toRegExpSource(t) {
    var u;
    const n = t ?? !!M(this, ce).dot;
    if (M(this, G) === this && pe(this, Re, $r).call(this), !this.type) {
      const f = this.isStart() && this.isEnd() && !M(this, I).some((m) => typeof m != "string"), l = M(this, I).map((m) => {
        var y;
        const [p, $, T, b] = typeof m == "string" ? pe(y = K, Se, Mr).call(y, m, M(this, H), f) : m.toRegExpSource(t);
        return D(this, H, M(this, H) || T), D(this, ge, M(this, ge) || b), p;
      }).join("");
      let a = "";
      if (this.isStart() && typeof M(this, I)[0] == "string" && !(M(this, I).length === 1 && sc.has(M(this, I)[0]))) {
        const p = ic, $ = (
          // dots are allowed, and the pattern starts with [ or .
          n && p.has(l.charAt(0)) || // the pattern starts with \., and then [ or .
          l.startsWith("\\.") && p.has(l.charAt(2)) || // the pattern starts with \.\., and then [ or .
          l.startsWith("\\.\\.") && p.has(l.charAt(4))
        ), T = !n && !t && p.has(l.charAt(0));
        a = $ ? oc : T ? et : "";
      }
      let d = "";
      return this.isEnd() && M(M(this, G), be) && ((u = M(this, P)) == null ? void 0 : u.type) === "!" && (d = "(?:$|\\/)"), [
        a + l + d,
        Ve(l),
        D(this, H, !!M(this, H)),
        M(this, ge)
      ];
    }
    const r = this.type === "*" || this.type === "+", o = this.type === "!" ? "(?:(?!(?:" : "(?:";
    let i = pe(this, Re, Ft).call(this, n);
    if (this.isStart() && this.isEnd() && !i && this.type !== "!") {
      const f = this.toString();
      return D(this, I, [f]), this.type = null, D(this, H, void 0), [f, Ve(this.toString()), !1, !1];
    }
    let s = !r || t || n || !et ? "" : pe(this, Re, Ft).call(this, !0);
    s === i && (s = ""), s && (i = `(?:${i})(?:${s})*?`);
    let c = "";
    if (this.type === "!" && M(this, He))
      c = (this.isStart() && !n ? et : "") + Rn;
    else {
      const f = this.type === "!" ? (
        // !() must match something,but !(x) can match ''
        "))" + (this.isStart() && !n && !t ? et : "") + On + ")"
      ) : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && s ? ")" : this.type === "*" && s ? ")?" : `)${this.type}`;
      c = o + i + f;
    }
    return [
      c,
      Ve(i),
      D(this, H, !!M(this, H)),
      M(this, ge)
    ];
  }
};
G = new WeakMap(), H = new WeakMap(), ge = new WeakMap(), I = new WeakMap(), P = new WeakMap(), me = new WeakMap(), Ee = new WeakMap(), be = new WeakMap(), ce = new WeakMap(), we = new WeakMap(), He = new WeakMap(), Re = new WeakSet(), $r = function() {
  if (this !== M(this, G))
    throw new Error("should only call on root");
  if (M(this, be))
    return this;
  this.toString(), D(this, be, !0);
  let t;
  for (; t = M(this, Ee).pop(); ) {
    if (t.type !== "!")
      continue;
    let n = t, r = M(n, P);
    for (; r; ) {
      for (let o = M(n, me) + 1; !r.type && o < M(r, I).length; o++)
        for (const i of M(t, I)) {
          if (typeof i == "string")
            throw new Error("string part in extglob AST??");
          i.copyIn(M(r, I)[o]);
        }
      n = r, r = M(n, P);
    }
  }
  return this;
}, Se = new WeakSet(), ot = function(t, n, r, o) {
  var g, m;
  let i = !1, s = !1, c = -1, u = !1;
  if (n.type === null) {
    let p = r, $ = "";
    for (; p < t.length; ) {
      const T = t.charAt(p++);
      if (i || T === "\\") {
        i = !i, $ += T;
        continue;
      }
      if (s) {
        p === c + 1 ? (T === "^" || T === "!") && (u = !0) : T === "]" && !(p === c + 2 && u) && (s = !1), $ += T;
        continue;
      } else if (T === "[") {
        s = !0, c = p, u = !1, $ += T;
        continue;
      }
      if (!o.noext && vn(T) && t.charAt(p) === "(") {
        n.push($), $ = "";
        const b = new K(T, n);
        p = pe(g = K, Se, ot).call(g, t, b, p, o), n.push(b);
        continue;
      }
      $ += T;
    }
    return n.push($), p;
  }
  let f = r + 1, l = new K(null, n);
  const a = [];
  let d = "";
  for (; f < t.length; ) {
    const p = t.charAt(f++);
    if (i || p === "\\") {
      i = !i, d += p;
      continue;
    }
    if (s) {
      f === c + 1 ? (p === "^" || p === "!") && (u = !0) : p === "]" && !(f === c + 2 && u) && (s = !1), d += p;
      continue;
    } else if (p === "[") {
      s = !0, c = f, u = !1, d += p;
      continue;
    }
    if (vn(p) && t.charAt(f) === "(") {
      l.push(d), d = "";
      const $ = new K(p, l);
      l.push($), f = pe(m = K, Se, ot).call(m, t, $, f, o);
      continue;
    }
    if (p === "|") {
      l.push(d), d = "", a.push(l), l = new K(null, n);
      continue;
    }
    if (p === ")")
      return d === "" && M(n, I).length === 0 && D(n, He, !0), l.push(d), d = "", n.push(...a, l), f;
    d += p;
  }
  return n.type = null, D(n, H, void 0), D(n, I, [t.substring(r - 1)]), f;
}, Ft = function(t) {
  return M(this, I).map((n) => {
    if (typeof n == "string")
      throw new Error("string type in extglob ast??");
    const [r, o, i, s] = n.toRegExpSource(t);
    return D(this, ge, M(this, ge) || s), r;
  }).filter((n) => !(this.isStart() && this.isEnd()) || !!n).join("|");
}, Mr = function(t, n, r = !1) {
  let o = !1, i = "", s = !1;
  for (let c = 0; c < t.length; c++) {
    const u = t.charAt(c);
    if (o) {
      o = !1, i += (cc.has(u) ? "\\" : "") + u;
      continue;
    }
    if (u === "\\") {
      c === t.length - 1 ? i += "\\\\" : o = !0;
      continue;
    }
    if (u === "[") {
      const [f, l, a, d] = nc(t, c);
      if (a) {
        i += f, s = s || l, c += a - 1, n = n || d;
        continue;
      }
    }
    if (u === "*") {
      i += r && t === "*" ? Rn : On, n = !0;
      continue;
    }
    if (u === "?") {
      i += Yt, n = !0;
      continue;
    }
    i += ac(u);
  }
  return [i, Ve(t), !!n, s];
}, Y(K, Se);
let gt = K;
const lc = (e, { windowsPathsNoEscape: t = !1, magicalBraces: n = !1 } = {}) => n ? t ? e.replace(/[?*()[\]{}]/g, "[$&]") : e.replace(/[?*()[\]\\{}]/g, "\\$&") : t ? e.replace(/[?*()[\]]/g, "[$&]") : e.replace(/[?*()[\]\\]/g, "\\$&"), B = (e, t, n = {}) => (dt(t), !n.nocomment && t.charAt(0) === "#" ? !1 : new yt(t, n).match(e)), uc = /^\*+([^+@!?\*\[\(]*)$/, fc = (e) => (t) => !t.startsWith(".") && t.endsWith(e), dc = (e) => (t) => t.endsWith(e), gc = (e) => (e = e.toLowerCase(), (t) => !t.startsWith(".") && t.toLowerCase().endsWith(e)), hc = (e) => (e = e.toLowerCase(), (t) => t.toLowerCase().endsWith(e)), pc = /^\*+\.\*+$/, mc = (e) => !e.startsWith(".") && e.includes("."), bc = (e) => e !== "." && e !== ".." && e.includes("."), yc = /^\.\*+$/, Sc = (e) => e !== "." && e !== ".." && e.startsWith("."), Tc = /^\*+$/, $c = (e) => e.length !== 0 && !e.startsWith("."), Mc = (e) => e.length !== 0 && e !== "." && e !== "..", Cc = /^\?+([^+@!?\*\[\(]*)?$/, Ec = ([e, t = ""]) => {
  const n = Cr([e]);
  return t ? (t = t.toLowerCase(), (r) => n(r) && r.toLowerCase().endsWith(t)) : n;
}, wc = ([e, t = ""]) => {
  const n = Er([e]);
  return t ? (t = t.toLowerCase(), (r) => n(r) && r.toLowerCase().endsWith(t)) : n;
}, vc = ([e, t = ""]) => {
  const n = Er([e]);
  return t ? (r) => n(r) && r.endsWith(t) : n;
}, Oc = ([e, t = ""]) => {
  const n = Cr([e]);
  return t ? (r) => n(r) && r.endsWith(t) : n;
}, Cr = ([e]) => {
  const t = e.length;
  return (n) => n.length === t && !n.startsWith(".");
}, Er = ([e]) => {
  const t = e.length;
  return (n) => n.length === t && n !== "." && n !== "..";
}, wr = typeof process == "object" && process ? typeof process.env == "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix", xn = {
  win32: { sep: "\\" },
  posix: { sep: "/" }
}, Rc = wr === "win32" ? xn.win32.sep : xn.posix.sep;
B.sep = Rc;
const re = Symbol("globstar **");
B.GLOBSTAR = re;
const xc = "[^/]", kc = xc + "*?", Ac = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?", Nc = "(?:(?!(?:\\/|^)\\.).)*?", Lc = (e, t = {}) => (n) => B(n, e, t);
B.filter = Lc;
const ne = (e, t = {}) => Object.assign({}, e, t), jc = (e) => {
  if (!e || typeof e != "object" || !Object.keys(e).length)
    return B;
  const t = B;
  return Object.assign((r, o, i = {}) => t(r, o, ne(e, i)), {
    Minimatch: class extends t.Minimatch {
      constructor(o, i = {}) {
        super(o, ne(e, i));
      }
      static defaults(o) {
        return t.defaults(ne(e, o)).Minimatch;
      }
    },
    AST: class extends t.AST {
      /* c8 ignore start */
      constructor(o, i, s = {}) {
        super(o, i, ne(e, s));
      }
      /* c8 ignore stop */
      static fromGlob(o, i = {}) {
        return t.AST.fromGlob(o, ne(e, i));
      }
    },
    unescape: (r, o = {}) => t.unescape(r, ne(e, o)),
    escape: (r, o = {}) => t.escape(r, ne(e, o)),
    filter: (r, o = {}) => t.filter(r, ne(e, o)),
    defaults: (r) => t.defaults(ne(e, r)),
    makeRe: (r, o = {}) => t.makeRe(r, ne(e, o)),
    braceExpand: (r, o = {}) => t.braceExpand(r, ne(e, o)),
    match: (r, o, i = {}) => t.match(r, o, ne(e, i)),
    sep: t.sep,
    GLOBSTAR: re
  });
};
B.defaults = jc;
const vr = (e, t = {}) => (dt(e), t.nobrace || !/\{(?:(?!\{).)*\}/.test(e) ? [e] : Ks(e));
B.braceExpand = vr;
const Fc = (e, t = {}) => new yt(e, t).makeRe();
B.makeRe = Fc;
const Ic = (e, t, n = {}) => {
  const r = new yt(t, n);
  return e = e.filter((o) => r.match(o)), r.options.nonull && !e.length && e.push(t), e;
};
B.match = Ic;
const kn = /[?*]|[+@!]\(.*?\)|\[|\]/, Dc = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
class yt {
  constructor(t, n = {}) {
    z(this, "options");
    z(this, "set");
    z(this, "pattern");
    z(this, "windowsPathsNoEscape");
    z(this, "nonegate");
    z(this, "negate");
    z(this, "comment");
    z(this, "empty");
    z(this, "preserveMultipleSlashes");
    z(this, "partial");
    z(this, "globSet");
    z(this, "globParts");
    z(this, "nocase");
    z(this, "isWindows");
    z(this, "platform");
    z(this, "windowsNoMagicRoot");
    z(this, "regexp");
    dt(t), n = n || {}, this.options = n, this.pattern = t, this.platform = n.platform || wr, this.isWindows = this.platform === "win32", this.windowsPathsNoEscape = !!n.windowsPathsNoEscape || n.allowWindowsEscape === !1, this.windowsPathsNoEscape && (this.pattern = this.pattern.replace(/\\/g, "/")), this.preserveMultipleSlashes = !!n.preserveMultipleSlashes, this.regexp = null, this.negate = !1, this.nonegate = !!n.nonegate, this.comment = !1, this.empty = !1, this.partial = !!n.partial, this.nocase = !!this.options.nocase, this.windowsNoMagicRoot = n.windowsNoMagicRoot !== void 0 ? n.windowsNoMagicRoot : !!(this.isWindows && this.nocase), this.globSet = [], this.globParts = [], this.set = [], this.make();
  }
  hasMagic() {
    if (this.options.magicalBraces && this.set.length > 1)
      return !0;
    for (const t of this.set)
      for (const n of t)
        if (typeof n != "string")
          return !0;
    return !1;
  }
  debug(...t) {
  }
  make() {
    const t = this.pattern, n = this.options;
    if (!n.nocomment && t.charAt(0) === "#") {
      this.comment = !0;
      return;
    }
    if (!t) {
      this.empty = !0;
      return;
    }
    this.parseNegate(), this.globSet = [...new Set(this.braceExpand())], n.debug && (this.debug = (...i) => console.error(...i)), this.debug(this.pattern, this.globSet);
    const r = this.globSet.map((i) => this.slashSplit(i));
    this.globParts = this.preprocess(r), this.debug(this.pattern, this.globParts);
    let o = this.globParts.map((i, s, c) => {
      if (this.isWindows && this.windowsNoMagicRoot) {
        const u = i[0] === "" && i[1] === "" && (i[2] === "?" || !kn.test(i[2])) && !kn.test(i[3]), f = /^[a-z]:/i.test(i[0]);
        if (u)
          return [...i.slice(0, 4), ...i.slice(4).map((l) => this.parse(l))];
        if (f)
          return [i[0], ...i.slice(1).map((l) => this.parse(l))];
      }
      return i.map((u) => this.parse(u));
    });
    if (this.debug(this.pattern, o), this.set = o.filter((i) => i.indexOf(!1) === -1), this.isWindows)
      for (let i = 0; i < this.set.length; i++) {
        const s = this.set[i];
        s[0] === "" && s[1] === "" && this.globParts[i][2] === "?" && typeof s[3] == "string" && /^[a-z]:$/i.test(s[3]) && (s[2] = "?");
      }
    this.debug(this.pattern, this.set);
  }
  // various transforms to equivalent pattern sets that are
  // faster to process in a filesystem walk.  The goal is to
  // eliminate what we can, and push all ** patterns as far
  // to the right as possible, even if it increases the number
  // of patterns that we have to process.
  preprocess(t) {
    if (this.options.noglobstar)
      for (let r = 0; r < t.length; r++)
        for (let o = 0; o < t[r].length; o++)
          t[r][o] === "**" && (t[r][o] = "*");
    const { optimizationLevel: n = 1 } = this.options;
    return n >= 2 ? (t = this.firstPhasePreProcess(t), t = this.secondPhasePreProcess(t)) : n >= 1 ? t = this.levelOneOptimize(t) : t = this.adjascentGlobstarOptimize(t), t;
  }
  // just get rid of adjascent ** portions
  adjascentGlobstarOptimize(t) {
    return t.map((n) => {
      let r = -1;
      for (; (r = n.indexOf("**", r + 1)) !== -1; ) {
        let o = r;
        for (; n[o + 1] === "**"; )
          o++;
        o !== r && n.splice(r, o - r);
      }
      return n;
    });
  }
  // get rid of adjascent ** and resolve .. portions
  levelOneOptimize(t) {
    return t.map((n) => (n = n.reduce((r, o) => {
      const i = r[r.length - 1];
      return o === "**" && i === "**" ? r : o === ".." && i && i !== ".." && i !== "." && i !== "**" ? (r.pop(), r) : (r.push(o), r);
    }, []), n.length === 0 ? [""] : n));
  }
  levelTwoFileOptimize(t) {
    Array.isArray(t) || (t = this.slashSplit(t));
    let n = !1;
    do {
      if (n = !1, !this.preserveMultipleSlashes) {
        for (let o = 1; o < t.length - 1; o++) {
          const i = t[o];
          o === 1 && i === "" && t[0] === "" || (i === "." || i === "") && (n = !0, t.splice(o, 1), o--);
        }
        t[0] === "." && t.length === 2 && (t[1] === "." || t[1] === "") && (n = !0, t.pop());
      }
      let r = 0;
      for (; (r = t.indexOf("..", r + 1)) !== -1; ) {
        const o = t[r - 1];
        o && o !== "." && o !== ".." && o !== "**" && (n = !0, t.splice(r - 1, 2), r -= 2);
      }
    } while (n);
    return t.length === 0 ? [""] : t;
  }
  // First phase: single-pattern processing
  // <pre> is 1 or more portions
  // <rest> is 1 or more portions
  // <p> is any portion other than ., .., '', or **
  // <e> is . or ''
  //
  // **/.. is *brutal* for filesystem walking performance, because
  // it effectively resets the recursive walk each time it occurs,
  // and ** cannot be reduced out by a .. pattern part like a regexp
  // or most strings (other than .., ., and '') can be.
  //
  // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
  // <pre>/<e>/<rest> -> <pre>/<rest>
  // <pre>/<p>/../<rest> -> <pre>/<rest>
  // **/**/<rest> -> **/<rest>
  //
  // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
  // this WOULD be allowed if ** did follow symlinks, or * didn't
  firstPhasePreProcess(t) {
    let n = !1;
    do {
      n = !1;
      for (let r of t) {
        let o = -1;
        for (; (o = r.indexOf("**", o + 1)) !== -1; ) {
          let s = o;
          for (; r[s + 1] === "**"; )
            s++;
          s > o && r.splice(o + 1, s - o);
          let c = r[o + 1];
          const u = r[o + 2], f = r[o + 3];
          if (c !== ".." || !u || u === "." || u === ".." || !f || f === "." || f === "..")
            continue;
          n = !0, r.splice(o, 1);
          const l = r.slice(0);
          l[o] = "**", t.push(l), o--;
        }
        if (!this.preserveMultipleSlashes) {
          for (let s = 1; s < r.length - 1; s++) {
            const c = r[s];
            s === 1 && c === "" && r[0] === "" || (c === "." || c === "") && (n = !0, r.splice(s, 1), s--);
          }
          r[0] === "." && r.length === 2 && (r[1] === "." || r[1] === "") && (n = !0, r.pop());
        }
        let i = 0;
        for (; (i = r.indexOf("..", i + 1)) !== -1; ) {
          const s = r[i - 1];
          if (s && s !== "." && s !== ".." && s !== "**") {
            n = !0;
            const u = i === 1 && r[i + 1] === "**" ? ["."] : [];
            r.splice(i - 1, 2, ...u), r.length === 0 && r.push(""), i -= 2;
          }
        }
      }
    } while (n);
    return t;
  }
  // second phase: multi-pattern dedupes
  // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
  // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
  // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
  //
  // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
  // ^-- not valid because ** doens't follow symlinks
  secondPhasePreProcess(t) {
    for (let n = 0; n < t.length - 1; n++)
      for (let r = n + 1; r < t.length; r++) {
        const o = this.partsMatch(t[n], t[r], !this.preserveMultipleSlashes);
        if (o) {
          t[n] = [], t[r] = o;
          break;
        }
      }
    return t.filter((n) => n.length);
  }
  partsMatch(t, n, r = !1) {
    let o = 0, i = 0, s = [], c = "";
    for (; o < t.length && i < n.length; )
      if (t[o] === n[i])
        s.push(c === "b" ? n[i] : t[o]), o++, i++;
      else if (r && t[o] === "**" && n[i] === t[o + 1])
        s.push(t[o]), o++;
      else if (r && n[i] === "**" && t[o] === n[i + 1])
        s.push(n[i]), i++;
      else if (t[o] === "*" && n[i] && (this.options.dot || !n[i].startsWith(".")) && n[i] !== "**") {
        if (c === "b")
          return !1;
        c = "a", s.push(t[o]), o++, i++;
      } else if (n[i] === "*" && t[o] && (this.options.dot || !t[o].startsWith(".")) && t[o] !== "**") {
        if (c === "a")
          return !1;
        c = "b", s.push(n[i]), o++, i++;
      } else
        return !1;
    return t.length === n.length && s;
  }
  parseNegate() {
    if (this.nonegate)
      return;
    const t = this.pattern;
    let n = !1, r = 0;
    for (let o = 0; o < t.length && t.charAt(o) === "!"; o++)
      n = !n, r++;
    r && (this.pattern = t.slice(r)), this.negate = n;
  }
  // set partial to true to test if, for example,
  // "/a/b" matches the start of "/*/b/*/d"
  // Partial means, if you run out of file before you run
  // out of pattern, then that's fine, as long as all
  // the parts match.
  matchOne(t, n, r = !1) {
    const o = this.options;
    if (this.isWindows) {
      const p = typeof t[0] == "string" && /^[a-z]:$/i.test(t[0]), $ = !p && t[0] === "" && t[1] === "" && t[2] === "?" && /^[a-z]:$/i.test(t[3]), T = typeof n[0] == "string" && /^[a-z]:$/i.test(n[0]), b = !T && n[0] === "" && n[1] === "" && n[2] === "?" && typeof n[3] == "string" && /^[a-z]:$/i.test(n[3]), y = $ ? 3 : p ? 0 : void 0, C = b ? 3 : T ? 0 : void 0;
      if (typeof y == "number" && typeof C == "number") {
        const [L, N] = [t[y], n[C]];
        L.toLowerCase() === N.toLowerCase() && (n[C] = L, C > y ? n = n.slice(C) : y > C && (t = t.slice(y)));
      }
    }
    const { optimizationLevel: i = 1 } = this.options;
    i >= 2 && (t = this.levelTwoFileOptimize(t)), this.debug("matchOne", this, { file: t, pattern: n }), this.debug("matchOne", t.length, n.length);
    for (var s = 0, c = 0, u = t.length, f = n.length; s < u && c < f; s++, c++) {
      this.debug("matchOne loop");
      var l = n[c], a = t[s];
      if (this.debug(n, l, a), l === !1)
        return !1;
      if (l === re) {
        this.debug("GLOBSTAR", [n, l, a]);
        var d = s, g = c + 1;
        if (g === f) {
          for (this.debug("** at the end"); s < u; s++)
            if (t[s] === "." || t[s] === ".." || !o.dot && t[s].charAt(0) === ".")
              return !1;
          return !0;
        }
        for (; d < u; ) {
          var m = t[d];
          if (this.debug(`
globstar while`, t, d, n, g, m), this.matchOne(t.slice(d), n.slice(g), r))
            return this.debug("globstar found match!", d, u, m), !0;
          if (m === "." || m === ".." || !o.dot && m.charAt(0) === ".") {
            this.debug("dot detected!", t, d, n, g);
            break;
          }
          this.debug("globstar swallow a segment, and continue"), d++;
        }
        return !!(r && (this.debug(`
>>> no match, partial?`, t, d, n, g), d === u));
      }
      let p;
      if (typeof l == "string" ? (p = a === l, this.debug("string match", l, a, p)) : (p = l.test(a), this.debug("pattern match", l, a, p)), !p)
        return !1;
    }
    if (s === u && c === f)
      return !0;
    if (s === u)
      return r;
    if (c === f)
      return s === u - 1 && t[s] === "";
    throw new Error("wtf?");
  }
  braceExpand() {
    return vr(this.pattern, this.options);
  }
  parse(t) {
    dt(t);
    const n = this.options;
    if (t === "**")
      return re;
    if (t === "")
      return "";
    let r, o = null;
    (r = t.match(Tc)) ? o = n.dot ? Mc : $c : (r = t.match(uc)) ? o = (n.nocase ? n.dot ? hc : gc : n.dot ? dc : fc)(r[1]) : (r = t.match(Cc)) ? o = (n.nocase ? n.dot ? wc : Ec : n.dot ? vc : Oc)(r) : (r = t.match(pc)) ? o = n.dot ? bc : mc : (r = t.match(yc)) && (o = Sc);
    const i = gt.fromGlob(t, this.options).toMMPattern();
    return o && typeof i == "object" && Reflect.defineProperty(i, "test", { value: o }), i;
  }
  makeRe() {
    if (this.regexp || this.regexp === !1)
      return this.regexp;
    const t = this.set;
    if (!t.length)
      return this.regexp = !1, this.regexp;
    const n = this.options, r = n.noglobstar ? kc : n.dot ? Ac : Nc, o = new Set(n.nocase ? ["i"] : []);
    let i = t.map((u) => {
      const f = u.map((a) => {
        if (a instanceof RegExp)
          for (const d of a.flags.split(""))
            o.add(d);
        return typeof a == "string" ? Dc(a) : a === re ? re : a._src;
      });
      f.forEach((a, d) => {
        const g = f[d + 1], m = f[d - 1];
        a !== re || m === re || (m === void 0 ? g !== void 0 && g !== re ? f[d + 1] = "(?:\\/|" + r + "\\/)?" + g : f[d] = r : g === void 0 ? f[d - 1] = m + "(?:\\/|\\/" + r + ")?" : g !== re && (f[d - 1] = m + "(?:\\/|\\/" + r + "\\/)" + g, f[d + 1] = re));
      });
      const l = f.filter((a) => a !== re);
      if (this.partial && l.length >= 1) {
        const a = [];
        for (let d = 1; d <= l.length; d++)
          a.push(l.slice(0, d).join("/"));
        return "(?:" + a.join("|") + ")";
      }
      return l.join("/");
    }).join("|");
    const [s, c] = t.length > 1 ? ["(?:", ")"] : ["", ""];
    i = "^" + s + i + c + "$", this.partial && (i = "^(?:\\/|" + s + i.slice(1, -1) + c + ")$"), this.negate && (i = "^(?!" + i + ").+$");
    try {
      this.regexp = new RegExp(i, [...o].join(""));
    } catch {
      this.regexp = !1;
    }
    return this.regexp;
  }
  slashSplit(t) {
    return this.preserveMultipleSlashes ? t.split("/") : this.isWindows && /^\/\/[^\/]+/.test(t) ? ["", ...t.split(/\/+/)] : t.split(/\/+/);
  }
  match(t, n = this.partial) {
    if (this.debug("match", t, this.pattern), this.comment)
      return !1;
    if (this.empty)
      return t === "";
    if (t === "/" && n)
      return !0;
    const r = this.options;
    this.isWindows && (t = t.split("\\").join("/"));
    const o = this.slashSplit(t);
    this.debug(this.pattern, "split", o);
    const i = this.set;
    this.debug(this.pattern, "set", i);
    let s = o[o.length - 1];
    if (!s)
      for (let c = o.length - 2; !s && c >= 0; c--)
        s = o[c];
    for (let c = 0; c < i.length; c++) {
      const u = i[c];
      let f = o;
      if (r.matchBase && u.length === 1 && (f = [s]), this.matchOne(f, u, n))
        return r.flipNegate ? !0 : !this.negate;
    }
    return r.flipNegate ? !1 : this.negate;
  }
  static defaults(t) {
    return B.defaults(t).Minimatch;
  }
}
B.AST = gt;
B.Minimatch = yt;
B.escape = lc;
B.unescape = Ve;
function It(e, t) {
  return t instanceof RegExp ? t.test(e) : t.includes("*") || t.includes("?") || t.includes("[") ? B(e, t) : e === t;
}
function Vc(e) {
  function t(a) {
    return Array.isArray(a) ? a.every((d) => typeof d == "string") : !1;
  }
  function n(a) {
    return a.trim();
  }
  function r() {
    var d;
    const a = (d = e.storage) == null ? void 0 : d.getItem(e.storageKey);
    if (a == null || a.length === 0)
      return [];
    try {
      const g = JSON.parse(a);
      return t(g) ? g.map(n).filter((m) => m.length > 0) : [];
    } catch {
      return [];
    }
  }
  function o(a) {
    if (e.storage) {
      if (a.length === 0) {
        e.storage.removeItem(e.storageKey);
        return;
      }
      e.storage.setItem(e.storageKey, JSON.stringify(a));
    }
  }
  function i(a, d) {
    return a.includes(d) ? [...a] : [...a, d];
  }
  let s = r();
  function c() {
    return [...s];
  }
  function u(a) {
    const d = n(a);
    d.length !== 0 && (s = i(s, d), o(s));
  }
  function f() {
    s = [], o(s);
  }
  function l(a) {
    for (const d of s)
      if (It(a, d))
        return !0;
    return !1;
  }
  return { addFilter: u, clearFilters: f, getFilters: c, matchesName: l };
}
let tt;
function St() {
  function e(a) {
    return typeof a == "object" && a !== null;
  }
  function t() {
    try {
      const a = Reflect.get(globalThis, "localStorage");
      if (!e(a)) return;
      const d = Reflect.get(a, "getItem"), g = Reflect.get(a, "setItem"), m = Reflect.get(a, "removeItem");
      return typeof d == "function" && typeof g == "function" && typeof m == "function" ? {
        getItem: (p) => {
          const $ = Reflect.apply(d, a, [p]);
          return typeof $ == "string" ? $ : null;
        },
        setItem: (p, $) => {
          Reflect.apply(g, a, [p, $]);
        },
        removeItem: (p) => {
          Reflect.apply(m, a, [p]);
        }
      } : void 0;
    } catch {
      return;
    }
  }
  function n(a) {
    return `exclude: { components: [${a.map((g) => JSON.stringify(g)).join(", ")}] }`;
  }
  if (tt) return tt;
  const r = Vc({
    storage: t(),
    storageKey: "__autotracer.react18.runtimeFilters.v1"
  });
  let o = !1;
  function i(a) {
    return o = a ?? !0, o;
  }
  function s(a) {
    r.addFilter(a);
  }
  function c() {
    r.clearFilters();
  }
  function u() {
    const a = n(r.getFilters());
    return console.log(a), a;
  }
  function f(a) {
    return r.matchesName(a);
  }
  function l(a) {
    return `autoTracer.reactTracer.addFilter(${JSON.stringify(a)})`;
  }
  return tt = {
    addFilter: s,
    clearFilters: c,
    showFilters: u,
    filterMode: i,
    isFilterModeEnabled: () => o,
    matchesName: f,
    createFilterAction: l
  }, tt;
}
function _c(e, t, n, r, o) {
  const {
    depth: i,
    displayName: s,
    renderType: c,
    flags: u,
    isTracked: f
  } = e;
  if (c === "Marker") {
    const T = "  ".repeat(Math.max(t, 0));
    if (x().showLevelDetails ?? !1) {
      const y = (o == null ? void 0 : o.depth) ?? i, C = e.filteredNodeCount ?? 0;
      J(
        `${T}└─┐ ... (Level: ${y}, Filtered nodes: ${C})`
      );
    } else
      J(`${T}└─┐ ${e.componentName}`);
    return t;
  }
  const l = "  ".repeat(t);
  if (t > n && t > 0 && !r) {
    const T = Math.max(n, 0), b = t - T, y = x().showLevelDetails ?? !1;
    if (b > 1)
      for (let C = T + 1; C < t; C++)
        J(Tn(C, i, y));
    J(Tn(t, i, y));
  }
  let a = "";
  u > 0 && x().showFlags && (a = ` (${ir(u).join(", ")})`);
  const d = `${l}├─ `, g = `[${s}] ${c}${a}`, m = St();
  function p(T) {
    return typeof T == "string" ? T : void 0;
  }
  const $ = m.isFilterModeEnabled() ? p(m.createFilterAction(s)) : void 0;
  return f ? rr(d, g, !0) : c === "Reconciled" ? tr(d, g) : c === "Skipped" ? nr(d, g) : J(`${d}${g}`), $ && J(`${l}│   %c${$}`, "font-size: 0.85em; font-weight: 400;"), hr(e, `${l}│   `), t;
}
function zc(e, t, n, r, o) {
  return _c(
    e,
    t,
    n,
    r,
    o
  );
}
const Pc = () => (e) => {
  h.debug(
    `createIndentedRenderer: Processing ${e.length} nodes`
  );
  const t = us(e);
  let n = -1, r = !1;
  for (let o = 0; o < e.length; o++)
    try {
      const i = e[o], s = t[o], c = o + 1 < e.length ? e[o + 1] : void 0;
      i !== void 0 && s !== void 0 && (n = zc(
        i,
        s,
        n,
        r,
        c
      ), r = i.renderType === "Marker");
    } catch (i) {
      h.error(`Error rendering node ${o}:`, i);
    }
  h.debug("createIndentedRenderer: Complete");
};
function Or(e, t) {
  return e.renderType !== "Marker" ? !0 : t;
}
function Wc(e, t, n) {
  const r = e[t];
  if (!r)
    return !1;
  for (let o = t + 1; o < e.length; o++) {
    const i = e[o];
    if (i && Or(i, n))
      return i.depth > r.depth;
  }
  return !1;
}
function Gc(e, t) {
  return t ? !0 : e.stateChanges.length > 0 || e.propChanges.length > 0 || e.componentLogs.length > 0;
}
function Uc(e, t, n) {
  const { displayName: r, renderType: o, flags: i, isTracked: s } = e;
  let c = "";
  i > 0 && n && (c = ` (${ir(i).join(", ")})`);
  const u = `[${r}] ${o}${c}`;
  return t ? s ? {
    logFn: Mi,
    args: ["", u, !0]
  } : o === "Reconciled" ? {
    logFn: yi,
    args: ["", u]
  } : o === "Skipped" ? {
    logFn: Si,
    args: ["", u]
  } : {
    logFn: er,
    args: [u]
  } : s ? {
    logFn: rr,
    args: ["", u, !0]
  } : o === "Reconciled" ? {
    logFn: tr,
    args: ["", u]
  } : o === "Skipped" ? {
    logFn: nr,
    args: ["", u]
  } : {
    logFn: J,
    args: [u]
  };
}
function Hc(e, t) {
  let n = 0;
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    if (o !== void 0 && o >= e)
      n++;
    else
      break;
  }
  return n;
}
const Bc = () => (e) => {
  function t(c) {
    return typeof c == "string" ? c : void 0;
  }
  const n = x().showLevelDetails ?? !1, r = x().showFlags ?? !1, o = St(), i = o.isFilterModeEnabled(), s = [];
  for (let c = 0; c < e.length; c++) {
    const u = e[c];
    if (!u || !Or(u, n))
      continue;
    if (u.renderType === "Marker" && n) {
      const p = e[c + 1], $ = (p == null ? void 0 : p.depth) ?? u.depth, T = u.filteredNodeCount ?? 0;
      J(`... (Level: ${$}, Filtered nodes: ${T})`);
      continue;
    }
    const f = Hc(u.depth, s);
    for (let p = 0; p < f; p++)
      lt(), s.pop();
    const l = Wc(e, c, n), a = Gc(u, l), d = Uc(u, a, r), g = i && u.renderType !== "Marker" ? o.createFilterAction(u.displayName) : void 0;
    d.logFn(...d.args);
    const m = t(g);
    m && J(`%c${m}`, "font-size: 0.85em; font-weight: 400;"), a && (s.push(u.depth), hr(u, ""));
  }
  for (; s.length > 0; )
    lt(), s.pop();
};
function qc(e) {
  function t(o) {
    return e.matchesName(o.displayName);
  }
  const n = [];
  let r;
  for (const o of e.nodes)
    if (!(r !== void 0 && o.depth > r)) {
      if (r !== void 0 && o.depth <= r && (r = void 0), o.renderType !== "Marker" && t(o)) {
        r = o.depth;
        continue;
      }
      n.push(o);
    }
  return n;
}
function Kc(e) {
  const t = h.enter(`renderTree: ENTER (${e.length} nodes)`), n = St(), r = qc({
    nodes: e,
    matchesName: n.matchesName
  });
  ((x().treeRenderingMode ?? "lineart") === "group" ? Bc() : Pc())(r), h.exit(t);
}
function Rr(e, t, n) {
  if (e instanceof Map)
    for (const [r, o] of e)
      Rr(o, [...t, r], n);
  else {
    const r = e;
    r.meta && n.push({
      functionName: r.meta.functionName,
      args: r.meta.args,
      timeMs: r.meta.firstComputeTimeMs,
      callerHits: r.meta.callerAccess
    });
  }
}
function Jc(e) {
  return e.map((t) => t === null ? "null" : t === void 0 ? "undefined" : typeof t == "string" ? `"${t}"` : typeof t == "number" || typeof t == "boolean" ? String(t) : typeof t == "function" ? "[Function]" : Array.isArray(t) ? `[Array(${t.length})]` : typeof t == "object" ? "[Object]" : String(t)).join(", ");
}
function Xc() {
  h.log(`
[auto-tracer] Function Cache Report:`);
  const e = [];
  for (const [, o] of st)
    Rr(o, [], e);
  if (e.length === 0) {
    h.log("  No cached function calls this render cycle.");
    return;
  }
  const t = /* @__PURE__ */ new Map();
  for (const o of e)
    t.has(o.functionName) || t.set(o.functionName, []), t.get(o.functionName).push(o);
  let n = 0, r = 0;
  for (const [o, i] of t) {
    h.log(`
${o}:`);
    let s = 0, c = 0;
    for (const u of i) {
      const f = Jc(u.args);
      h.log(
        `  Arguments: ${f} (computed in ${u.timeMs.toFixed(2)}ms)`
      );
      let l = 0, a = 0;
      for (const [d, g] of u.callerHits) {
        const m = (g - 1) * u.timeMs;
        h.log(
          `    ${d}: ${g} hits (saved ${m.toFixed(2)}ms)`
        ), l += g, a += m;
      }
      h.log(
        `    Total: ${l} hits, saved ${a.toFixed(2)}ms`
      ), s += l, c += a;
    }
    h.log(
      `  Overall: ${i.length} unique argument combinations, ${s} total hits, ${c.toFixed(
        2
      )}ms saved`
    ), n += c, r += i.length;
  }
  h.log(
    `
Grand Total: ${r} unique argument combinations across all functions`
  ), h.log(
    `Total time saved by caching: ${n.toFixed(2)}ms
`
  );
}
function An() {
  x().functionCache && x().functionCacheLogging && Xc(), st.clear();
}
const xr = "autotracer-react-enabled-on-load", Dt = "autotracer-react-autostop-renders", ht = "autotracer-react-start-trigger", pt = "autotracer-react-end-trigger", Zt = "autotracer-react-end-trigger-mode", Qt = "autotracer-react-trigger-rearm";
function kr() {
  try {
    const e = localStorage.getItem(xr);
    return e === null ? null : e === "true";
  } catch {
    return null;
  }
}
function Yc(e) {
  try {
    localStorage.setItem(xr, String(e));
  } catch {
  }
}
function Ar() {
  try {
    const e = localStorage.getItem(Dt);
    if (e === null) return null;
    const t = parseInt(e, 10);
    return isNaN(t) || t <= 0 ? null : t;
  } catch {
    return null;
  }
}
function Zc(e) {
  try {
    e === null || e <= 0 ? localStorage.removeItem(Dt) : localStorage.setItem(Dt, String(e));
  } catch {
  }
}
function Nr() {
  try {
    const e = localStorage.getItem(ht);
    return e === null || e.trim().length === 0 ? null : e;
  } catch {
    return null;
  }
}
function Qc(e) {
  try {
    e === null || e.trim().length === 0 ? localStorage.removeItem(ht) : localStorage.setItem(ht, e);
  } catch {
  }
}
function Lr() {
  try {
    const e = localStorage.getItem(pt);
    return e === null || e.trim().length === 0 ? null : e;
  } catch {
    return null;
  }
}
function ea(e) {
  try {
    e === null || e.trim().length === 0 ? localStorage.removeItem(pt) : localStorage.setItem(pt, e);
  } catch {
  }
}
function jr() {
  try {
    return localStorage.getItem(Zt) === "on-entry" ? "on-entry" : "on-exit";
  } catch {
    return "on-exit";
  }
}
function ta(e) {
  try {
    localStorage.setItem(Zt, e);
  } catch {
  }
}
function Fr() {
  try {
    return localStorage.getItem(Qt) === "always" ? "always" : "once";
  } catch {
    return "once";
  }
}
function na(e) {
  try {
    localStorage.setItem(Qt, e);
  } catch {
  }
}
function ra() {
  try {
    localStorage.removeItem(ht), localStorage.removeItem(pt), localStorage.removeItem(Zt), localStorage.removeItem(Qt);
  } catch {
  }
}
function oa(e, t, n, r, o, i, s, c, u, f, l) {
  return {
    start: e,
    stop: t,
    isEnabled: n,
    setEnabledOnLoad: (a) => {
      Yc(a);
    },
    getEnabledOnLoad: () => kr() ?? !1,
    setAutoStopAfterRenders: (a) => {
      Zc(a), i(a);
    },
    getAutoStopAfterRenders: () => Ar(),
    getRenderCount: r,
    resetRenderCount: o,
    setStartTrigger: (a) => {
      Qc(a), s(a), a !== null && l();
    },
    getStartTrigger: () => Nr(),
    setEndTrigger: (a) => {
      ea(a), c(a);
    },
    getEndTrigger: () => Lr(),
    setEndTriggerMode: (a) => {
      ta(a), u(a);
    },
    getEndTriggerMode: () => jr(),
    setTriggerRearmMode: (a) => {
      na(a), f(a);
    },
    getTriggerRearmMode: () => Fr(),
    clearAllTriggers: () => {
      ra(), s(null), c(null), u("on-exit"), f("once");
    }
  };
}
function ia(e, t) {
  if (t == null)
    return !1;
  if (t instanceof RegExp)
    return It(e, t);
  const n = t.trim();
  return n.length === 0 ? !1 : It(e, n);
}
function ae() {
  return globalThis.__autoTracerInternal || (globalThis.__autoTracerInternal = {
    outputMode: "devtools",
    subscribers: []
  }), globalThis.__autoTracerInternal.sharedControl || (globalThis.__autoTracerInternal.sharedControl = {
    isReactTracerActive: !1,
    isPassiveHookInstalled: !1,
    isIntendedToBeEnabled: !1,
    hasInitializedOnce: !1,
    originalOnCommitFiberRoot: null
  }), globalThis.__autoTracerInternal.sharedControl;
}
let en = !1;
function sa() {
  return en;
}
function ca(e) {
  en = e;
}
function Vt() {
  en = !1;
}
let de = null, _t = null, Pe = null, Tt = null, tn = null, nn = "on-exit", rn = "once";
function aa(e) {
  de = e;
}
function la(e) {
  _t = e;
}
function ua(e) {
  Pe = e;
}
function fa(e) {
  Tt = e;
}
function da() {
  return Tt;
}
function ga(e) {
  tn = e;
}
function ha(e) {
  nn = e;
}
function pa(e) {
  rn = e;
}
function Nn() {
  Pe = Ar();
}
function Ln() {
  Tt = Nr(), tn = Lr(), nn = jr(), rn = Fr();
}
function xt(e, t) {
  if (!t)
    return !1;
  for (const n of e)
    if (ia(n.displayName, t))
      return !0;
  return !1;
}
function jn(e) {
  const t = h.enter("detectUpdatedComponents", "trace");
  try {
    const n = e;
    if (!(n != null && n.current)) {
      h.exit(t);
      return;
    }
    Mo();
    const r = h.enter("Tree building", "trace"), o = os(n.current, 0);
    h.exit(r);
    const i = Tt, s = rn, c = ae().isIntendedToBeEnabled, u = s === "once" && sa();
    !c && i && !u && xt(o, i) && (h.log(
      `Start trigger matched: ${i}, starting tracer`
    ), ca(!0), _t && _t());
    const f = ae().isIntendedToBeEnabled;
    if (h.info(`[DEBUG detectUpdatedComponents] isIntendedToBeEnabled: ${f}`), !f) {
      h.info("[DEBUG detectUpdatedComponents] Tracer disabled, returning early"), Ie(), h.exit(t);
      return;
    }
    if (Pe !== null) {
      const b = vo();
      b >= Pe && de && (h.log(
        `Auto-stop triggered: reached ${b} renders since start (limit: ${Pe})`
      ), de());
    }
    const l = tn, a = nn;
    if (a === "on-entry" && xt(o, l)) {
      s === "always" && Vt(), de == null || de(), Ie(), An(), h.exit(t);
      return;
    }
    const d = x().filterEmptyNodes ?? "none", g = h.enter(
      `Filtering (${d})`,
      "trace"
    ), p = ls(d)(o, {
      includeReconciled: x().includeReconciled ?? "never",
      includeSkipped: x().includeSkipped ?? "never",
      includeMount: x().includeMount ?? "never",
      includeRendered: x().includeRendered ?? "never"
    });
    h.debug(
      `Filtering (${d}): ${o.length} → ${p.length} nodes`
    ), h.exit(g);
    const $ = p.some((b) => b.renderType !== "Marker");
    if ($) {
      const { cycleNumber: b, filteredCount: y } = Co();
      Eo();
      const C = y > 0 ? `Component render cycle ${b} (${y} filtered):` : `Component render cycle ${b}:`;
      er(C);
    }
    const T = h.enter("Rendering", "trace");
    Kc(p), h.exit(T), Ie(), An(), a === "on-exit" && xt(o, l) && (h.log(
      `End trigger matched (on-exit): ${l}, stopping tracer`
    ), s === "always" && Vt(), de == null || de()), $ && lt(), h.exit(t);
  } catch (n) {
    lt(), h.error(
      "ReactTracer: Error during component detection:",
      n
    );
    try {
      Ie();
    } catch (r) {
      h.error("ReactTracer: Error during cleanup:", r);
    }
    h.exit(t);
  }
}
var ma = function(t) {
  return ba(t) && !ya(t);
};
function ba(e) {
  return !!e && typeof e == "object";
}
function ya(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || $a(e);
}
var Sa = typeof Symbol == "function" && Symbol.for, Ta = Sa ? Symbol.for("react.element") : 60103;
function $a(e) {
  return e.$$typeof === Ta;
}
function Ma(e) {
  return Array.isArray(e) ? [] : {};
}
function Ue(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Le(Ma(e), e, t) : e;
}
function Ca(e, t, n) {
  return e.concat(t).map(function(r) {
    return Ue(r, n);
  });
}
function Ea(e, t) {
  if (!t.customMerge)
    return Le;
  var n = t.customMerge(e);
  return typeof n == "function" ? n : Le;
}
function wa(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Fn(e) {
  return Object.keys(e).concat(wa(e));
}
function Ir(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function va(e, t) {
  return Ir(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function Oa(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Fn(e).forEach(function(o) {
    r[o] = Ue(e[o], n);
  }), Fn(t).forEach(function(o) {
    va(e, o) || (Ir(e, o) && n.isMergeableObject(t[o]) ? r[o] = Ea(o, n)(e[o], t[o], n) : r[o] = Ue(t[o], n));
  }), r;
}
function Le(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || Ca, n.isMergeableObject = n.isMergeableObject || ma, n.cloneUnlessOtherwiseSpecified = Ue;
  var r = Array.isArray(t), o = Array.isArray(e), i = r === o;
  return i ? r ? n.arrayMerge(e, t, n) : Oa(e, t, n) : Ue(t, n);
}
Le.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, o) {
    return Le(r, o, n);
  }, {});
};
var Ra = Le, xa = Ra;
const on = /* @__PURE__ */ Bn(xa);
function ka(e) {
  const t = qn.colors;
  if (!e)
    return t;
  const n = Object.fromEntries(
    Object.entries(e).filter(([r, o]) => o !== void 0)
  );
  return Object.keys(n).length === 0 ? t : on(t, n, {
    // Replace arrays instead of concatenating (preserves array reference)
    arrayMerge: (r, o) => o
  });
}
function Aa(e) {
  return e == null ? 500 : typeof e != "number" || isNaN(e) ? (Ne("ReactTracer: Invalid maxFiberDepth, using default (500)"), 500) : e < 20 ? (Ne("ReactTracer: maxFiberDepth too low, using minimum (20)"), 20) : e > 1e3 ? (Ne("ReactTracer: maxFiberDepth too high, using maximum (1000)"), 1e3) : Math.floor(e);
}
function Dr(e) {
  function t(i) {
    if (i !== void 0) {
      if (i === "devtools" || i === "copy-paste")
        return i;
      Ne("ReactTracer: Invalid outputMode, using default ('devtools')");
    }
  }
  const n = t(e.outputMode), { outputMode: r, ...o } = e;
  return {
    ...o,
    ...n === void 0 ? {} : { outputMode: n },
    maxFiberDepth: Aa(e.maxFiberDepth)
  };
}
function Vr(e, t) {
  function n(o) {
    const i = o;
    Object.entries(i).forEach((s) => {
      const [c, u] = s;
      u === void 0 && delete i[c];
    });
  }
  const r = { ...t };
  return n(r), on(e, r, {
    // Replace arrays instead of concatenating (preserves array reference)
    arrayMerge: (o, i) => i
  });
}
function Na(e, t, n) {
  const r = t !== null ? { ...e, enabled: t } : e, o = globalThis.__REACTTRACER_THEME__ ?? {}, i = on(
    r.colors ?? {},
    o,
    {
      arrayMerge: (l, a) => a
    }
  ), s = ka(i), c = {
    ...r,
    colors: s
  }, u = Dr(c), f = Vr(n, u);
  return { validatedOptions: u, mergedOptions: f };
}
function La(e, t) {
  return {
    start: e.start,
    stop: e.stop,
    isEnabled: e.isEnabled,
    setEnabledOnLoad: e.setEnabledOnLoad,
    getEnabledOnLoad: e.getEnabledOnLoad,
    setAutoStopAfterRenders: e.setAutoStopAfterRenders,
    getAutoStopAfterRenders: e.getAutoStopAfterRenders,
    getRenderCount: e.getRenderCount,
    resetRenderCount: e.resetRenderCount,
    setStartTrigger: e.setStartTrigger,
    getStartTrigger: e.getStartTrigger,
    setEndTrigger: e.setEndTrigger,
    getEndTrigger: e.getEndTrigger,
    setEndTriggerMode: e.setEndTriggerMode,
    getEndTriggerMode: e.getEndTriggerMode,
    setTriggerRearmMode: e.setTriggerRearmMode,
    getTriggerRearmMode: e.getTriggerRearmMode,
    clearAllTriggers: e.clearAllTriggers,
    addFilter: t.addFilter,
    showFilters: t.showFilters,
    clearFilters: t.clearFilters,
    filterMode: t.filterMode
  };
}
function _r() {
  try {
    return typeof window > "u" ? null : window.__REACT_DEVTOOLS_GLOBAL_HOOK__ || null;
  } catch (e) {
    return h.warn(
      "ReactTracer: Error accessing React DevTools hook:",
      e
    ), null;
  }
}
function zt() {
  return _r() !== null;
}
function In(e, t) {
  try {
    const n = _r();
    if (!n)
      return null;
    const r = t || n.onCommitFiberRoot;
    return n.onCommitFiberRoot = e, r;
  } catch (n) {
    return h.error("ReactTracer: Error installing render hook:", n), null;
  }
}
function Dn(e, t = !1) {
  return (n, r, o) => {
    try {
      e(n, r, o);
    } catch (i) {
      h.error("ReactTracer: Error in render hook:", i);
    }
  };
}
function ja(e = !1) {
  zt() ? h.debug("ReactTracer: React DevTools detected") : h.warn(
    `ReactTracer: React DevTools not available. To use ReactTracer, either:\r
  1. Install the React DevTools browser extension, OR\r
  2. Use the @autotracer/plugin-vite-react18 or @autotracer/plugin-babel-react18 plugin\r
Automatic Tracing will not work without one of these options.`
  );
}
function zr() {
  function e(l) {
    return typeof l == "object" && l !== null;
  }
  function t(l) {
    return l === "devtools" || l === "copy-paste";
  }
  function n(l) {
    return e(l) ? typeof l.getOutputMode == "function" && typeof l.setOutputMode == "function" : !1;
  }
  function r() {
    let l = !1;
    function a() {
    }
    function d() {
    }
    function g() {
      return !1;
    }
    function m(E) {
    }
    function p() {
      return "exclude: { components: [] }";
    }
    function $() {
    }
    function T(E) {
      return l = E ?? !0, l;
    }
    function b(E) {
    }
    function y() {
      return !1;
    }
    function C(E) {
    }
    function L() {
      return null;
    }
    function N() {
      return 0;
    }
    function te() {
    }
    function ue(E) {
    }
    function F() {
      return null;
    }
    function xe(E) {
    }
    function ke() {
      return null;
    }
    function $e(E) {
    }
    function Me() {
      return "on-exit";
    }
    function $t(E) {
    }
    function U() {
      return "once";
    }
    function S() {
    }
    return {
      start: a,
      stop: d,
      isEnabled: g,
      addFilter: m,
      showFilters: p,
      clearFilters: $,
      filterMode: T,
      setEnabledOnLoad: b,
      getEnabledOnLoad: y,
      setAutoStopAfterRenders: C,
      getAutoStopAfterRenders: L,
      getRenderCount: N,
      resetRenderCount: te,
      setStartTrigger: ue,
      getStartTrigger: F,
      setEndTrigger: xe,
      getEndTrigger: ke,
      setEndTriggerMode: $e,
      getEndTriggerMode: Me,
      setTriggerRearmMode: $t,
      getTriggerRearmMode: U,
      clearAllTriggers: S
    };
  }
  function o() {
    return globalThis.__autoTracerInternal !== void 0 || (globalThis.__autoTracerInternal = {
      outputMode: "devtools",
      subscribers: []
    }), globalThis.__autoTracerInternal;
  }
  const i = globalThis.autoTracer;
  if (n(i))
    return o(), i;
  const s = o();
  function c() {
    return s.outputMode;
  }
  function u(l) {
    t(l) && (s.outputMode = l, s.subscribers.forEach((a) => {
      a(l);
    }));
  }
  const f = {
    getOutputMode: c,
    setOutputMode: u,
    reactTracer: r()
  };
  return e(i) && Object.keys(i).forEach((l) => {
    l in f || Reflect.set(f, l, Reflect.get(i, l));
  }), globalThis.autoTracer = f, f;
}
function Vn(e) {
  zr();
  const t = globalThis.__autoTracerInternal;
  t !== void 0 && (t.outputMode !== "devtools" && t.outputMode !== "copy-paste" || (t.subscribers.push(e), e(t.outputMode)));
}
function _e() {
  const e = ae();
  if (e.isIntendedToBeEnabled = !1, e.isPassiveHookInstalled && !e.isReactTracerActive) {
    e.isPassiveHookInstalled = !1, e.originalOnCommitFiberRoot = null, Vt(), h.debug("ReactTracer: Cleaned up passive hook");
    return;
  }
  if (!e.isReactTracerActive) {
    e.isPassiveHookInstalled = !1;
    return;
  }
  if (Ie(), e.isReactTracerActive = !1, e.originalOnCommitFiberRoot) {
    e.isPassiveHookInstalled = !0;
    const t = da() ? " (start trigger active)" : "";
    h.info(
      `ReactTracer: Global render monitor stopped (passive mode${t})`
    );
  } else
    e.isPassiveHookInstalled = !1, h.debug("ReactTracer: Stopped (no hook was installed)");
}
function Fa() {
  const e = nt(/* @__PURE__ */ new Map());
  return {
    get: (t, n) => {
      const r = `${t}-${n}`;
      return e.current.get(r);
    },
    set: (t, n, r) => {
      const o = `${t}-${n}`;
      e.current.set(o, r);
    }
  };
}
let _n = !1, Ia = 0;
function Ua(e) {
  Gr(Ge);
  const t = x(), n = ae().isReactTracerActive, r = nt(), o = nt(n), i = Fa(), s = nt(!0);
  o.current = n, r.current || (r.current = `render-track-${++Ia}-${Date.now()}`);
  const c = Ur(() => ({
    log: (f, ...l) => {
      o.current && ze.addLog(
        r.current,
        "log",
        f,
        ...l
      );
    },
    warn: (f, ...l) => {
      o.current && ze.addLog(
        r.current,
        "warn",
        f,
        ...l
      );
    },
    error: (f, ...l) => {
      o.current && ze.addLog(
        r.current,
        "error",
        f,
        ...l
      );
    },
    /**
     * **Internal API - Not intended for direct developer use**
     *
     * Associates human-readable label(s) with a state hook for debugging purposes.
     * This method is primarily used by the react-tracer Vite plugin during build-time
     * AST transformation to automatically label useState/useSelector hooks.
     *
     * While always available at runtime, developers should generally not call this
     * method directly as the Vite plugin handles labeling automatically.
     *
     * @param index Build-time ordinal position (source order)
     * @param nameValuePairs Alternating name-value pairs: "name1", value1, "name2", value2, ...
     *
     * @example
     * ```tsx
     * // Automatically handled by Vite plugin:
     * const todos = useSelector(selectTodos);
     * // Plugin injects: logger.labelState(0, "todos", todos);
     *
     * // For multi-variable hooks:
     * const [count, setCount] = useState(0);
     * // Plugin injects: logger.labelState(0, "count", count, "setCount", setCount);
     * ```
     */
    labelState: (f, ...l) => {
      if (o.current)
        try {
          const a = r.current, d = s.current;
          if (typeof f != "number")
            throw new Error(
              "ReactTracer: labelState requires an explicit index as first argument."
            );
          f === 0 && Yr(a);
          for (let g = 0; g < l.length; g += 2) {
            const m = l[g], p = l[g + 1];
            if (typeof m == "string") {
              const $ = d ? void 0 : i.get(f, m), T = {
                label: m,
                index: f,
                value: p
              };
              d || (T.prevValue = $), Jr(a, T), i.set(f, m, p);
            }
          }
          d && (s.current = !1);
        } catch (a) {
          Ne(
            `ReactTracer: Error storing labels for index ${f}:`,
            a
          );
        }
    }
  }), []), u = typeof e == "string" ? e : e == null ? void 0 : e.name;
  return Jo(r.current, u), !n && t.enabled === !0 && !_n && (_n = !0, h.info(
    "ReactTracer: useReactTracer() called while tracer not initialized. Call reactTracer() early in app startup."
  )), c;
}
function Ha() {
  return ae().isReactTracerActive;
}
function Da(e, t) {
  const n = Dr(t);
  return Vr(e, n);
}
function Va(e, t, n) {
  return e === !0 && t === !1 && n;
}
function Ba(e) {
  const t = x(), n = t.enabled, r = Da(t, e);
  Hn(r.internalLogLevel), Nt(r), Xn(e);
  const o = ae().isReactTracerActive;
  Va(n, r.enabled, o) && _e();
}
function _a(e = {}) {
  const t = ae(), n = t.hasInitializedOnce ? null : kr();
  t.hasInitializedOnce = !0;
  const { validatedOptions: r, mergedOptions: o } = Na(
    e,
    n,
    x()
  );
  Hn(o.internalLogLevel), Nt(o), Xn(e);
  function i() {
    if (t.isReactTracerActive || t.isPassiveHookInstalled || !zt())
      return;
    const d = Dn(
      (g, m, p) => {
        t.originalOnCommitFiberRoot && typeof t.originalOnCommitFiberRoot == "function" && t.originalOnCommitFiberRoot(
          g,
          m,
          p
        ), jn(m);
      },
      !1
    );
    t.originalOnCommitFiberRoot = In(d), t.isPassiveHookInstalled = !0;
  }
  function s() {
    if (t.isReactTracerActive)
      return;
    if (t.isIntendedToBeEnabled = !0, Nn(), fn(), Ln(), t.isPassiveHookInstalled) {
      t.isPassiveHookInstalled = !1, t.isReactTracerActive = !0, h.info(
        "ReactTracer: Global render monitor activated (was in passive mode)"
      );
      return;
    }
    const d = { ...x(), enabled: !0 };
    _a(d);
  }
  const c = oa(
    s,
    _e,
    () => ae().isIntendedToBeEnabled,
    Oo,
    wo,
    ua,
    fa,
    ga,
    ha,
    pa,
    i
  );
  aa(_e), la(s), Ln();
  const u = St(), f = zr();
  f.reactTracer = La(c, u), r.outputMode !== void 0 && f.setOutputMode(r.outputMode);
  function l(d) {
    const g = Kn(d), m = { ...x(), ...g };
    Nt(m);
  }
  if (x().enabled === !1)
    return ae().isIntendedToBeEnabled = !1, Vn(l), h.debug("ReactTracer: Disabled via enabled: false option"), i(), () => {
    };
  if (Vn(l), t.isIntendedToBeEnabled = !0, t.isReactTracerActive)
    return h.debug(
      "ReactTracer is already active. Returning existing cleanup function."
    ), _e;
  if (!zt())
    return ja(!1), () => {
    };
  const a = Dn(
    (d, g, m) => {
      const p = ae();
      p.originalOnCommitFiberRoot && typeof p.originalOnCommitFiberRoot == "function" && p.originalOnCommitFiberRoot(
        d,
        g,
        m
      ), jn(g);
    },
    !1
    // Logger handles internal logging now
  );
  return t.originalOnCommitFiberRoot = In(a), Nn(), fn(), t.isReactTracerActive = !0, h.info("ReactTracer: Global render monitor initialized"), _e;
}
export {
  Ha as isRenderMonitorActive,
  _a as reactTracer,
  _e as stopReactTracer,
  Ba as updateReactTracerOptions,
  Ua as useReactTracer
};
